// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:57.162Z
// Property: Waterford Place (ID: 6737460151191774)
// Collections: 43 amenities, 7 floorplans (live), 44 photos, 69 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191774",
  "property_external_id": "5026485",
  "property_zillow_url": "https://www.zillow.com/b/waterford-place-apartments-greenville-nc-5XhyqF/",
  "property_apartments_url": "https://www.apartments.com/waterford-place-greenville-nc/1qnhs95",
  "property_google_business_url": "https://www.google.com/maps/place/Waterford+Place/data=!4m2!3m1!1s0x0:0x51c866fe6579d71d?sa=X&ved=2ahUKEwj_mMaewbySAxUShv0HHdp5Il0Q_BJ6BAgIEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321266755",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "waterford-place",
  "property_name": "Waterford Place",
  "property_website_url": "https://www.liveatwaterfordplaceapts.com/",
  "property_domain": "https://www.liveatwaterfordplaceapts.com/",
  "property_address": "2792 Stantonsburg Rd",
  "property_full_address": "2792 Stantonsburg Rd, Greenville, NC 27834",
  "property_address_1": "2792 Stantonsburg Rd",
  "property_address_2": null,
  "property_address_city": "Greenville",
  "property_address_state": "NC",
  "property_address_zip_full": "27834",
  "property_address_zip": "27834",
  "property_address_country": "US",
  "property_address_county": "Pitt County",
  "property_neighborhood_address": "Medical District",
  "property_address_latitude": "35.6087676",
  "property_address_longitude": "-77.4254213",
  "property_email": "waterfordplace@rrliving.com",
  "property_phone": "(252) 757-0079",
  "property_call_tracking_phone": "252-680-2142",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Waterford Place in Greenville, NC, where modern living meets exceptional amenities. Choose from spacious one, two, or three-bedroom floor plans and enjoy features like a dog park, gas fire pit, and 24-hour fitness center. Live life fully—make Waterford Place your new home today!",
  "property_long_description": "**Welcome to Waterford Place – Your Ideal Greenville, NC Retreat!**\n\nDiscover the perfect blend of comfort, convenience, and community at Waterford Place, where our spacious one-bedroom, two-bedroom, and three-bedroom apartments await you. Nestled in the heart of Greenville, NC, our gated community offers a serene escape with direct access to the scenic Vulcan Trail, perfect for a morning jog or evening stroll.\n\nAt Waterford Place, we pride ourselves on exceptional amenities designed to enhance your lifestyle. Enjoy leisurely weekends at our two sparkling pools, unwind by the gas fire pit, or socialize in the stylish clubroom. For those who value fitness, our 24-hour fitness center is equipped with free weights and the latest machinery, ensuring you always have access when it’s convenient for you.\n\nYour safety and comfort are our top priorities. Enjoy peace of mind with 24-hour on-call maintenance and management, plus controlled building access. Our ample parking options, including covered and garage spaces, provide added convenience.\n\nPet lovers will appreciate our dog park and bark park, where your furry friends can play freely. Families can make use of our community playgrounds and basketball court, ensuring there’s something for everyone to enjoy.\n\nAt Waterford Place, we also provide essential services such as a business center with conference room access, clothes care center, and car wash stations, making your daily life that much easier. \n\nExplore the endless possibilities that await you—find your new home today! Browse our availability or schedule a tour to visit our vibrant community. Experience the Waterford Place lifestyle and make it your own!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-f518-734c-a1e1-f933d3f10e2c.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool with lounge chairs and a brick building in the background.",
    "public_id": "019e84a3-f518-734c-a1e1-f933d3f10e2c",
    "storage_key": "property/6737460151191774/019e84a3-f518-734c-a1e1-f933d3f10e2c.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "432",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.83333333333334",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "No breed restrictions; each apartment may have up to 3 pets, with a limit of 2 dogs per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://liveatwaterfordplaceapts.loftliving.com/login",
  "property_apply_now_url": "https://8921440.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-d314-7318-80b5-9cb2a64ec457.webp",
  "property_primary_logo_media": {
    "alt_text": "Waterford Place logo",
    "public_id": "019e84a3-d314-7318-80b5-9cb2a64ec457",
    "storage_key": "property/6737460151191774/019e84a3-d314-7318-80b5-9cb2a64ec457.webp",
    "width": 1463,
    "height": 683
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-b631-72db-959b-99cdfeafe451.webp",
  "property_secondary_logo_media": {
    "alt_text": "Waterford Place logo",
    "public_id": "019e1e15-b631-72db-959b-99cdfeafe451",
    "storage_key": "property/6737460151191774/019e1e15-b631-72db-959b-99cdfeafe451.webp",
    "width": 351,
    "height": 164
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e8e87-737e-7726-81a5-cc4699fe151a.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-737e-7726-81a5-cc4699fe151a",
    "storage_key": "property/6737460151191774/019e8e87-737e-7726-81a5-cc4699fe151a.webp",
    "width": 1280,
    "height": 597
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e8e87-684f-70ae-97c4-441d1c045534.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-684f-70ae-97c4-441d1c045534",
    "storage_key": "property/6737460151191774/019e8e87-684f-70ae-97c4-441d1c045534.webp",
    "width": 1280,
    "height": 597
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "805 - 1363",
  "property_sqft_min": "805",
  "property_sqft_max": "1363",
  "property_price_range": "1005 - 1705",
  "property_price_min": "1005",
  "property_price_max": "1705",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/people/Waterford-Place-Apartments/61554653005060/",
  "property_instagram_url": "https://www.instagram.com/waterford_place_rr_living",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJJ7JrVSvorokRHdd5Zf5myFE",
  "property_youtube_url": "https://www.youtube.com/watch?v=a7CLMyfAXoE",
  "property_yelp_url": "https://www.yelp.com/biz/waterford-place-hickory",
  "property_tiktok_url": "https://www.tiktok.com/@waterford.place.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Waterford Place",
  "property_home_romance_title": "Find Your Heart’s Home in Our Vibrant Community",
  "property_home_amenities_blurb": "<p>Join us at the gated Waterford Place in Greenville, NC for a superior living experience. Near Westwood with John P East Memorial Highway close by, Waterford Place allows unbeatable access to the city’s best venues. Make your next move to a great location with an airport and public transportation only a few miles away for endless adventures and return to a top-quality and <a href=\"/floor-plans/\">highly comfortable apartment.</a></p>",
  "property_home_floorplans_blurb": "<p>Ideally located in Greenville, NC, the neighborhood surrounding <a href=\"/floor-plans/\">Waterford Place</a> has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_home_gallery_blurb": "At Waterford Place in Greenville, NC, our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—offer a lifestyle brimming with comfort. Enjoy 24-hour access, community amenities like a refreshing pool and fitness center, and the tranquility of a pet-friendly environment. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Greenville, NC, Waterford Place offers an inviting neighborhood vibe. Choose from stylish one, two, or three-bedroom floor plans that redefine modern living. Savor local favorites and discover nearby gems — your vibrant community awaits just steps from home. Embrace the lifestyle you deserve today!",
  "property_home_reviews_blurb": "At Waterford Place in Greenville, NC, residents rave about the “safe, clean, pleasant” atmosphere and luxurious amenities. Enjoy spacious floor plans, two sparkling pools, and quick maintenance responses. Experience a sanctuary that combines comfort and convenience—perfect for new graduates or anyone seeking a tranquil lifestyle. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Ideally located in Greenville, NC, the neighborhood surrounding <a href=\"/floor-plans/\">Waterford Place</a> has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Hang out and play shuffleboard, indulge in a tennis match with friends, or lounge in the elegant clubhouse of our community.Stay active at our fitness center, unwind in the refreshing swimming pool, and let your pets roam freely in the leash-free park. For a luxurious lifestyle, contact our management team that is always on-site and waiting for you to come home to Waterford Place in Greenville, <a href=\"/neighborhood/\">North Carolina.</a></p>",
  "property_applynow_blurb": "At Waterford Place in Greenville, NC, modern living meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like two sparkling pools, a vibrant dog park, and a state-of-the-art fitness center. Seamlessly lease online today, and elevate your lifestyle in our gated community!",
  "property_contactus_blurb": "At Waterford Place in Greenville, NC, our thoughtfully designed one, two, and three-bedroom floor plans invite you to experience modern living tailored to your lifestyle. Ready to find your perfect fit? Connect with our leasing team today for all your questions and let us welcome you home! ",
  "property_faqs_blurb": "At Waterford Place in Greenville, NC, we offer versatile floor plans tailored to your lifestyle—choose from one, two, or three-bedroom layouts. Curious about our community? Our FAQs page has all the answers you need. Dive in and learn how Waterford Place can be your new home!",
  "property_floorplans_blurb": "<p>An assortment of floor plans with one, two, and three bedroom apartment homes for <a href=\"/amenities/\">rent feature</a> plush carpeted floors to quiet each step, a balcony or patio, and we’ve created a gourmet kitchen with plenty of space, a dishwasher, and microwave. Air conditioning and ceiling fans ensure it is always the right temperature!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Waterford Place in Greenville, NC, your ideal home awaits! Choose from one, two, or three-bedroom floor plans and enjoy amenities like two sparkling pools, a dog park, and a 24-hour fitness center. Use our interactive community map to explore apartments and pricing today—your perfect lifestyle begins here!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Waterford Place in Greenville, NC, our diverse floor plans—one, two, and three bedrooms—are designed to complement your lifestyle. Share the joy of great living with those you care about. Great friends make great neighbors, so refer a friend to join our welcoming community today!",
  "property_residentaccess_blurb": "Welcome to Waterford Place in vibrant Greenville, NC, where our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Ready to simplify your life? Access your resident portal to manage rent, schedule maintenance, and enjoy seamless living at its best! Your comfort starts here.",
  "property_reviews_blurb": "At Waterford Place in Greenville, NC, residents praise our tranquil living environment, highlighting a \"safe, clean, and pleasant\" experience. With spacious floor plans and quick maintenance response times, our community blends luxury with comfort. Dive into our inviting pools and see why so many love calling Waterford Place home!",
  "property_created_at": "1752257096162",
  "property_scheduletour_blurb": "At Waterford Place in Greenville, NC, our diverse floor plans cater to your lifestyle—choose from cozy one-bedroom retreats to spacious three-bedroom homes. Experience the vibrant community spirit that makes us unique. Join us for a tour and hear firsthand from our residents about what makes Waterford Place their home sweet home!",
  "property_thankyou_blurb": "Thank you for reaching out to Waterford Place in beautiful Greenville, NC! Our inviting community offers thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Expect a member of our team to connect with you soon to help find your perfect home at Waterford Place!",
  "property_virtualtours_blurb": "<p>At Waterford Place, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Waterford Place",
  "property_seo_title_home": "Waterford Place | Apartments in GREENVILLE, NC",
  "property_seo_description_home": "Welcome to Waterford Place in Greenville, NC, where modern living meets unparalleled convenience. Choose from one, two, or three-bedroom floor plans designed for your lifestyle. Enjoy resort-style amenities like a 24-hour fitness center, two sparkling pools, and a vibrant clubhouse. Relax by the gas fire pit or host a BBQ in our outdoor grilling area. With 24/7 management and maintenance, along with direct access to the scenic Vulcan trail, you'll experience peace of mind and community at every turn. Your new home awaits—join us at Waterford Place!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in GREENVILLE, NC",
  "property_seo_description_floorplans": "Unveil your ideal living space at Waterford Place in Greenville, NC. With thoughtfully designed floor plans ranging from cozy one-bedroom nooks to spacious three-bedroom retreats, our apartments cater to every lifestyle. Whether you're looking for a quaint hideaway or a family-friendly haven, each option is crafted with comfort in mind. Browse our available apartment homes today and find a floor plan that feels just right for you!",
  "property_seo_title_amenities": "Amenities | GREENVILLE, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience the charm of Waterford Place in Greenville, NC, where luxury meets lifestyle. Choose from spacious one, two, or three-bedroom floor plans, and indulge in top-notch amenities like two sparkling pools, a 24-hour fitness center, and a cozy gas fire pit perfect for gatherings. With gated security, ample parking, and a vibrant clubhouse, every need is met in our welcoming community designed for comfort and convenience. Elevate your living experience—discover how Waterford Place redefines apartment living today!",
  "property_seo_title_gallery": "Gallery | Apartments in GREENVILLE, NC",
  "property_seo_description_gallery": "\"Immerse yourself in the vibrant lifestyle at Waterford Place in Greenville, NC. With versatile floor plans from cozy one-bedroom retreats to spacious three-bedroom havens, you'll find the perfect fit. Enjoy community perks like two sparkling pools, a state-of-the-art fitness center, and a welcoming dog park. Picture yourself unwinding by the gas fire pit or hosting friends at the clubhouse. Don’t just dream about your ideal apartment – see it come to life in our stunning photo gallery!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Waterford Place Apartments",
  "property_seo_description_virtualtours": "Step into the vibrant lifestyle of Waterford Place in Greenville, NC! Browse our stunning one, two, and three-bedroom floor plans that cater to your every need. Ready to envision your future home? Experience it now with our immersive virtual tour—your next chapter awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Waterford Place Apartments",
  "property_seo_description_interactivemap": "Elevate your lifestyle at Waterford Place in Greenville, NC! Choose from spacious one, two, and three-bedroom apartments surrounded by exceptional amenities—including two sparkling pools, a 24-hour fitness center, and a welcoming dog park. Enjoy community gas grills, ample covered parking, and direct access to the scenic Vulcan trail. With 24/7 on-call management and maintenance, your comfort is our priority. Uncover your ideal apartment with our interactive community map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in GREENVILLE, NC",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle of Waterford Place in Greenville, NC! Nestled in a lively neighborhood, our community boasts easy access to local favorites, scenic parks, and cultural hotspots. From cozy one-bedroom retreats to spacious three-bedroom havens, find your perfect floor plan and enjoy everything our area has to offer. Venture out and uncover the hidden gems right beyond your doorstep!",
  "property_seo_title_contact": "Contact Us | Waterford Place",
  "property_seo_description_contact": "Looking for your next home in Greenville, NC? Waterford Place offers thoughtfully designed one, two, and three-bedroom apartments perfect for your lifestyle. With a welcoming community and modern amenities, every corner feels like home. Have questions? Reach out to our friendly leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in GREENVILLE, NC",
  "property_seo_description_faqs": "\"At Waterford Place in Greenville, NC, your perfect apartment awaits! With spacious one, two, and three-bedroom floor plans and an array of top-notch amenities like gas grills, a 24-hour fitness center, and direct access to the scenic Vulcan trail, we offer an unparalleled living experience. Enjoy the convenience of a dog park, sparkling pools, and even a car wash area—everything you need for a vibrant lifestyle. Have questions? Dive into our FAQs page for insights about our gated community and resident perks!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in GREENVILLE, NC",
  "property_seo_description_reviews": "\"Welcome to Waterford Place in Greenville, NC, where modern living meets exceptional amenities! Choose from spacious one, two, or three-bedroom floor plans and enjoy access to our luxurious pools, 24-hour fitness center, and inviting clubroom. With features like dog parks, basketball courts, and a car wash area, your lifestyle will thrive here. Don’t just take our word for it—see what our residents are saying about their experience at Waterford Place and discover why this gated community feels like home!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in GREENVILLE, NC",
  "property_seo_description_applynow": "Experience the perfect blend of comfort and community at Waterford Place in Greenville, NC. Our thoughtfully designed one, two, and three-bedroom apartments offer an array of luxurious amenities including sparkling pools, a state-of-the-art 24-hour fitness center, and a cozy gas fire pit for memorable evenings. Enjoy easy access to the Vulcan trail and a vibrant clubhouse, with dog parks and playgrounds for your furry friends and little ones. With 24/7 management and maintenance, you can find peace of mind in your ideal home. Why wait? Claim your spot in our gated community today and lease online for a fresh start!",
  "property_seo_title_residentaccess": "Resident Access | Waterford Place",
  "property_seo_description_residentaccess": "\"Welcome back to Waterford Place in Greenville, NC! Log in to your resident portal for seamless rent payments, hassle-free maintenance scheduling, and exclusive community updates. Your upgraded living experience awaits!\"",
  "property_seo_title_referafriend": "Refer A Friend | Waterford Place",
  "property_seo_description_referafriend": "\"At Waterford Place in Greenville, NC, great friends create the best living experiences. Join our vibrant community by referring a friend today, and enjoy exclusive rewards together! Make your neighborhood feel like home.\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Waterford Place",
  "property_seo_description_scheduletour": "\"Step into serenity at Waterford Place in Greenville, NC. Experience the charm of our vibrant apartment community and envision your new lifestyle. Ready to make it yours? Schedule a tour today!\"",
  "property_seo_title_privacy": "Privacy Policy | Waterford Place",
  "property_seo_description_privacy": "\"At Waterford Place in Greenville, NC, your privacy matters. Dive into our comprehensive privacy policy to understand how we safeguard your personal information while you enjoy the comforts of home. Your security is our priority—learn more today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Waterford Place",
  "property_seo_description_accessibility": "\"At Waterford Place in Greenville, NC, we prioritize digital accessibility for all. Our commitment to inclusivity ensures that everyone can easily navigate our community online. Join us in making every experience seamless and welcoming.\"",
  "property_seo_title_sitemap": "Sitemap | Waterford Place",
  "property_seo_description_sitemap": "\"Unlock the hidden gems of Waterford Place in Greenville, NC, with our comprehensive sitemap. Navigate effortlessly through your future home and uncover the amenities, floor plans, and vibrant community features ready to welcome you. Your journey to the perfect apartment starts here!\"",
  "property_seo_title_thankyou": "Thank You | Waterford Place",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Waterford Place in Greenville, NC! One of our team members will connect with you soon to help you discover your perfect home in our vibrant community. Your journey to comfortable living begins here!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in GREENVILLE, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293557771",
  "amenities": [
    {
      "id": "custom_271b76a8-e929-4084-b11d-1b82f90c58ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "3 Dog Parks",
      "amount": "false",
      "description": "Verified: exactly as listed on official site",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ada135da-d919-4e45-a88a-ca66eb56f06c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_691b0a3d-3676-44bf-8d1b-c0acb6d6367c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e562924-0a8b-4c06-ade0-c67b5fea8b94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Corn Hole Game Area",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0800018e-2878-493d-989c-366d746e6d6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Gazebo",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28fe2b54-56d3-4d19-82de-7fbf46d16153",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ed91756-96f7-4a04-9d03-3280eb280dff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8acf4cca-ffa1-4ccd-823f-aa34aa46110d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Management",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1dbac01-7715-4f41-aa6f-d60cfde6f494",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_543b2529-4a84-4955-bdf9-c191d1bf4ed8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Grilling Areas",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc9dc78e-9f01-4983-9fa0-dfd8e706d950",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5ab60d5-e41a-4b9c-9b0e-2ca600ef329a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Reservable Event Space",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54474ac8-0250-4a25-b16f-7bb2e2a821b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff6ab075-349a-4589-8db8-118f7de8540e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Shuffle Board and an All‑in‑One Game Table",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2fe9df05-5394-4523-b1f1-5374e4aed501",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Smoke‑free",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8955deec-6c37-43b0-a8f2-42b4b8b70579",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d985823a-260f-40b2-8d8e-354b7fe97db0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Tennis Court",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_855be0ca-b260-4ece-abd1-dc27d5670348",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_45bdaa19-7ffa-40e4-baaf-ca828b63d8c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df7502f0-312d-4c38-966a-16ce945c4a8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "2 Resort Style Swimming Pools",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_add25527-25f6-43f4-a8a8-54e38b73bf91",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Access to Secure Parcel Lockers",
      "amount": "false",
      "description": "Verified",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4c0a256-6f24-4247-b17a-e4f6479a207c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5d3c89dd-4046-4a0a-a782-45c4f6658f60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb3e67ad-7e52-43bc-8bde-05fd54c4c5a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37c307c9-a6bb-43ea-bd06-7adbc7b71f69",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Carpeted Floors",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c90d6cc-ae7f-4bd6-807b-886d9d46d0d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9229c606-ee05-4a8b-8baf-41570bb3ca67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Crown Molding",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d42b3da8-f981-4926-a0e0-b919fa2bf69d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_19e2253e-cba3-4966-b909-297d4f9d4ccb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Double Vanities",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_75664102-0151-4d20-bf57-f73ce22c3e1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7a38ad5-bba0-4a10-b99f-c8775f224071",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "Verified (with asterisk, matching site)",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_882d88a0-1826-4d54-852b-c2b838733075",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ab81780-e716-42cc-a99c-0a70d6939a29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "High‑speed Internet Access",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7803ae4e-9272-4778-b884-21991cf9d058",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Ice Maker*",
      "amount": "false",
      "description": "Verified (with asterisk)",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecb7a8e2-4cdf-4fb3-b535-6ab8d43f3316",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14da9266-44c7-4ddc-9a55-81ab2dde27be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b110b2e-43a2-4514-9e47-86d8a30bc9cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2b4ee7a-d8cb-40c1-95da-690e0bab4d80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Patio or Balcony*",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e57278ee-5f17-492b-bb43-c4c8d4392ba5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc78ec09-4992-4023-888e-63a70e1721df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "Verified (with asterisk)",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_adf2c277-bafd-4deb-968f-69539c6fcc56",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑in Closets",
      "amount": "false",
      "description": "Verified",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_833e9efd-889d-4a01-a3ec-84d5549a3372",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections*",
      "amount": "false",
      "description": "Verified (with asterisk)",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8c55372-86f9-4a3f-b0a4-565f3fc254a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer in Home*",
      "amount": "false",
      "description": "Verified (with asterisk)",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_5a4692d9-8f86-4efb-b4b2-3f03e183283a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-875f-72bc-8695-4e12e473e5e8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0f8e8-875f-72bc-8695-4e12e473e5e8",
        "storage_key": "property/6737460151191774/01a0f8e8-875f-72bc-8695-4e12e473e5e8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_79849339-13b0-483e-982e-53320c823abb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-8a90-732e-90c9-f2a0ee011046.webp",
      "image_media": {
        "alt_text": "Fully equipped fitness center with weight machines, free weights, and cardio equipment.",
        "public_id": "01a0f8e8-8a90-732e-90c9-f2a0ee011046",
        "storage_key": "property/6737460151191774/01a0f8e8-8a90-732e-90c9-f2a0ee011046.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide range of cardio machines and weight training equipment.",
      "link": "",
      "alt_text": "Fully equipped fitness center with weight machines, free weights, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bcfd4639-4ff2-4184-8546-812bd73c32ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-85c8-746b-bd6d-e1b2584576e5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "01a0f8e8-85c8-746b-bd6d-e1b2584576e5",
        "storage_key": "property/6737460151191774/01a0f8e8-85c8-746b-bd6d-e1b2584576e5.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience effortless meal preparation in this sleek, modern kitchen featuring pristine white cabinetry, durable granite countertops, and a full suite of stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ccc51b70-378b-4d4a-b994-9bd2a5149654",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-8751-743c-bcc5-b90c151f9166.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black appliances, and a sink.",
        "public_id": "01a0f8e8-8751-743c-bcc5-b90c151f9166",
        "storage_key": "property/6737460151191774/01a0f8e8-8751-743c-bcc5-b90c151f9166.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring light wood cabinetry, a black stove and microwave, and a double sink. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, black appliances, and a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d94408a1-d8a1-456a-918c-f84feab2d580",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-883e-752d-9616-c707ffd197b3.webp",
      "image_media": {
        "alt_text": "Living room and dining area with sofa, coffee table, dining set, and kitchen view.",
        "public_id": "01a0f8e8-883e-752d-9616-c707ffd197b3",
        "storage_key": "property/6737460151191774/01a0f8e8-883e-752d-9616-c707ffd197b3.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable sofa, a round wooden coffee table, and a dining set, with a view into the open kitchen and a hallway leading to the entrance.",
      "link": "",
      "alt_text": "Living room and dining area with sofa, coffee table, dining set, and kitchen view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21ce534e-57ee-4112-8e88-088af8d02ea6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-88a2-72d9-87ca-d5c7f10d3daf.webp",
      "image_media": {
        "alt_text": "A primary bedroom with a king-sized bed, nightstands, and a dresser.",
        "public_id": "01a0f8e8-88a2-72d9-87ca-d5c7f10d3daf",
        "storage_key": "property/6737460151191774/01a0f8e8-88a2-72d9-87ca-d5c7f10d3daf.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Cozy primary bedroom featuring a king-sized bed, comfortable bedding, and elegant decor. Perfect for relaxation.",
      "link": "",
      "alt_text": "A primary bedroom with a king-sized bed, nightstands, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dd22b755-340c-45a6-97ef-717978895031",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-8735-725f-b131-62a130a4e6f7.webp",
      "image_media": {
        "alt_text": "Laundry room with washer and dryer in apartment.",
        "public_id": "01a0f8e8-8735-725f-b131-62a130a4e6f7",
        "storage_key": "property/6737460151191774/01a0f8e8-8735-725f-b131-62a130a4e6f7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with a full-size washer and dryer, ready for your use.",
      "link": "",
      "alt_text": "Laundry room with washer and dryer in apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b52430d1-a9a2-41b6-b5a3-923bc4544a30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-89bc-71d8-b9a2-d19053cab4ce.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a large vanity, toilet, and shower with a striped curtain.",
        "public_id": "01a0f8e8-89bc-71d8-b9a2-d19053cab4ce",
        "storage_key": "property/6737460151191774/01a0f8e8-89bc-71d8-b9a2-d19053cab4ce.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully appointed bathroom, featuring a spacious vanity, modern fixtures, and a serene shower space.",
      "link": "",
      "alt_text": "Modern bathroom with a large vanity, toilet, and shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_06dcd694-4317-4ff4-b9c2-f8f580ce6d4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-889a-7559-ad15-22bee5671fcf.webp",
      "image_media": {
        "alt_text": "Package lockers and a wooden door with glass panes in a community common area.",
        "public_id": "01a0f8e8-889a-7559-ad15-22bee5671fcf",
        "storage_key": "property/6737460151191774/01a0f8e8-889a-7559-ad15-22bee5671fcf.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Secure package lockers are available for residents, alongside a convenient community entrance.",
      "link": "",
      "alt_text": "Package lockers and a wooden door with glass panes in a community common area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74acebf4-4942-4e41-96fb-2eb5cf65d163",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/01a0f8e8-87d8-70b8-aad5-d7c5bfce7c7b.webp",
      "image_media": {
        "alt_text": "Playground with slides, swings, and climbing structure in a grassy area.",
        "public_id": "01a0f8e8-87d8-70b8-aad5-d7c5bfce7c7b",
        "storage_key": "property/6737460151191774/01a0f8e8-87d8-70b8-aad5-d7c5bfce7c7b.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with slides, swings, and a climbing dome for endless entertainment.",
      "link": "",
      "alt_text": "Playground with slides, swings, and climbing structure in a grassy area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9717dcb-417e-482b-8364-c3543fdda423",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-f518-734c-a1e1-f933d3f10e2c.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a brick building in the background.",
        "public_id": "019e84a3-f518-734c-a1e1-f933d3f10e2c",
        "storage_key": "property/6737460151191774/019e84a3-f518-734c-a1e1-f933d3f10e2c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and beautiful landscaping.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a brick building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5a841aed-e5cc-4945-bfc0-6d6cd54db5e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-d23a-77ba-8be7-a3ae31c50cf4.webp",
      "image_media": {
        "alt_text": "Sleek and modern community lounge with two neutral-toned sofas, a wooden coffee table, and botanical art.",
        "public_id": "019e84a3-d23a-77ba-8be7-a3ae31c50cf4",
        "storage_key": "property/6737460151191774/019e84a3-d23a-77ba-8be7-a3ae31c50cf4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring comfortable seating and tasteful decor.",
      "link": "",
      "alt_text": "Sleek and modern community lounge with two neutral-toned sofas, a wooden coffee table, and botanical art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a09fc9a5-892e-4404-b10b-855fbccb0778",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-d8b5-7359-96b8-ccccffa76499.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
        "public_id": "019e1e15-d8b5-7359-96b8-ccccffa76499",
        "storage_key": "property/6737460151191774/019e1e15-d8b5-7359-96b8-ccccffa76499.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "This apartment kitchen features bright white cabinets, elegant granite countertops, and a full suite of stainless steel appliances, including a microwave, stove, and dishwasher. A deep double sink and ample counter space make this kitchen perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dcc63f52-7245-425a-8a6d-e8cfb3ca5449",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-e40c-7615-97f7-8e59c7c53fde.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstands, ceiling fan, and a window with blinds.",
        "public_id": "019e1e15-e40c-7615-97f7-8e59c7c53fde",
        "storage_key": "property/6737460151191774/019e1e15-e40c-7615-97f7-8e59c7c53fde.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a queen-size bed, stylish nightstands, and a ceiling fan for year-round comfort. Natural light streams in through the window, creating a serene atmosphere.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstands, ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b0e1983-1654-49d2-ae38-a91244d8450e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-d8a7-770d-a0a6-6cd4f69736db.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with breakfast bar in apartment",
        "public_id": "019e1e15-d8a7-770d-a0a6-6cd4f69736db",
        "storage_key": "property/6737460151191774/019e1e15-d8a7-770d-a0a6-6cd4f69736db.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room seamlessly flowing into the kitchen, featuring a breakfast bar with stools and modern appliances. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with breakfast bar in apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01e30ec4-bcc0-4882-8feb-1e2ad566740c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-dd06-731f-8ccd-4608240d3862.webp",
      "image_media": {
        "alt_text": "A neutral toned bedroom with a desk and chair, two accent chairs, and a ceiling fan.",
        "public_id": "019e1e15-dd06-731f-8ccd-4608240d3862",
        "storage_key": "property/6737460151191774/019e1e15-dd06-731f-8ccd-4608240d3862.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "This bedroom features a desk, chair, and accent seating, perfect for a home office or cozy reading nook. A ceiling fan keeps the room comfortable.",
      "link": "",
      "alt_text": "A neutral toned bedroom with a desk and chair, two accent chairs, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b9f3b4e6-c91c-4c0e-aecc-6d77c8226aa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-e5c4-74d9-b0ac-eede37471451.webp",
      "image_media": {
        "alt_text": "Blue tennis court with apartment buildings in the background.",
        "public_id": "019e84a3-e5c4-74d9-b0ac-eede37471451",
        "storage_key": "property/6737460151191774/019e84a3-e5c4-74d9-b0ac-eede37471451.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our vibrant blue tennis court, surrounded by the beautiful apartment community and lush greenery.",
      "link": "",
      "alt_text": "Blue tennis court with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bdd2a3d-39f6-42dc-a721-ce79dc0ac132",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-f468-73eb-b843-2de23ec9225a.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with comfortable seating, decorative artwork, and elegant wooden ceiling.",
        "public_id": "019e84a3-f468-73eb-b843-2de23ec9225a",
        "storage_key": "property/6737460151191774/019e84a3-f468-73eb-b843-2de23ec9225a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge, featuring plush seating, tasteful artwork, and a striking vaulted wood ceiling.",
      "link": "",
      "alt_text": "Modern communal lounge area with comfortable seating, decorative artwork, and elegant wooden ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3738476c-35e5-46ba-97ca-897fa15d9d17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a4-0a9b-75f8-90ac-82570e130c60.webp",
      "image_media": {
        "alt_text": "Business center with computers and a community news board near the pool entrance.",
        "public_id": "019e84a4-0a9b-75f8-90ac-82570e130c60",
        "storage_key": "property/6737460151191774/019e84a4-0a9b-75f8-90ac-82570e130c60.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Community",
      "description": "Stay connected in our business center, complete with computers and printing, or check the community news board for updates. Step outside to our refreshing pool area.",
      "link": "",
      "alt_text": "Business center with computers and a community news board near the pool entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1514d84f-31e2-46e7-b5ac-684c5bd1b5a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a4-046a-72ee-a227-44320aab75c9.webp",
      "image_media": {
        "alt_text": "Comfortable seating area in the community lounge with a stone fireplace and view of the pool.",
        "public_id": "019e84a4-046a-72ee-a227-44320aab75c9",
        "storage_key": "property/6737460151191774/019e84a4-046a-72ee-a227-44320aab75c9.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy stone fireplace and large windows offering a glimpse of the sparkling pool area.",
      "link": "",
      "alt_text": "Comfortable seating area in the community lounge with a stone fireplace and view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8458226c-1171-4e93-bdd1-b80328347fb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-f76c-72ab-b762-15ad86faac28.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
        "public_id": "019e84a3-f76c-72ab-b762-15ad86faac28",
        "storage_key": "property/6737460151191774/019e84a3-f76c-72ab-b762-15ad86faac28.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and picturesque buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92ac3c08-802b-4fad-9791-f41fab531d87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-ff82-7153-9eea-c253dd632ab4.webp",
      "image_media": {
        "alt_text": "Clubhouse interior with a stone fireplace, seating area, and vaulted wood ceiling.",
        "public_id": "019e84a3-ff82-7153-9eea-c253dd632ab4",
        "storage_key": "property/6737460151191774/019e84a3-ff82-7153-9eea-c253dd632ab4.webp",
        "width": 2500,
        "height": 1668
      },
      "title": "Community",
      "description": "Relax and socialize in the community clubhouse, featuring a cozy stone fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Clubhouse interior with a stone fireplace, seating area, and vaulted wood ceiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e912fb6-80f5-4dfe-8456-33fac1d364a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-fc79-74f9-9a80-c9d285be6959.webp",
      "image_media": {
        "alt_text": "Brick apartment building with balconies and a green lawn.",
        "public_id": "019e84a3-fc79-74f9-9a80-c9d285be6959",
        "storage_key": "property/6737460151191774/019e84a3-fc79-74f9-9a80-c9d285be6959.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Beautifully maintained brick apartment building with white balconies and lush green landscaping. Enjoy a comfortable and convenient lifestyle.",
      "link": "",
      "alt_text": "Brick apartment building with balconies and a green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3de14a6-c0fb-49c1-9e4e-841aa48e6ca3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-f951-7375-93b6-1e7762526fe4.webp",
      "image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures in a grassy area.",
        "public_id": "019e84a3-f951-7375-93b6-1e7762526fe4",
        "storage_key": "property/6737460151191774/019e84a3-f951-7375-93b6-1e7762526fe4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring colorful slides, climbing walls, and plenty of space for children to play.",
      "link": "",
      "alt_text": "Playground with slides, swings, and climbing structures in a grassy area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0181f1e1-62f6-4491-9766-857245ba7025",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-faa1-77cb-ab99-a3e4344402ce.webp",
      "image_media": {
        "alt_text": "Tennis court and surrounding green space at apartment complex.",
        "public_id": "019e84a3-faa1-77cb-ab99-a3e4344402ce",
        "storage_key": "property/6737460151191774/019e84a3-faa1-77cb-ab99-a3e4344402ce.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy active days on our tennis court, or relax in the surrounding green spaces. A perfect amenity for a vibrant community lifestyle.",
      "link": "",
      "alt_text": "Tennis court and surrounding green space at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2373da41-fcbd-4cb9-a883-21fb26bdd32b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-fa5b-7640-aeb2-21c534a4dad1.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer.",
        "public_id": "019e84a3-fa5b-7640-aeb2-21c534a4dad1",
        "storage_key": "property/6737460151191774/019e84a3-fa5b-7640-aeb2-21c534a4dad1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay connected in our resident business center, featuring computers and a printer for your convenience.",
      "link": "",
      "alt_text": "Business center with computers and printer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_68739f23-9379-4e56-af26-58427cae2bc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-f5b3-714c-8e8d-f58dbf843402.webp",
      "image_media": {
        "alt_text": "Covered picnic pavilion with picnic tables and a playground in the background.",
        "public_id": "019e84a3-f5b3-714c-8e8d-f58dbf843402",
        "storage_key": "property/6737460151191774/019e84a3-f5b3-714c-8e8d-f58dbf843402.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in the covered picnic pavilion, complete with picnic tables and a nearby playground for family fun.",
      "link": "",
      "alt_text": "Covered picnic pavilion with picnic tables and a playground in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8da0f16d-bb2a-4fff-974f-f86d64e7947a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-ea3b-750c-aaa1-ad42bb1495da.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with a green fire hydrant and a waste station.",
        "public_id": "019e84a3-ea3b-750c-aaa1-ad42bb1495da",
        "storage_key": "property/6737460151191774/019e84a3-ea3b-750c-aaa1-ad42bb1495da.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Our community features a dedicated dog park, perfect for your furry friends to play and socialize in a safe, fenced environment. Includes a convenient waste station for easy cleanup.",
      "link": "",
      "alt_text": "A fenced-in dog park with a green fire hydrant and a waste station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d86d98f-5f33-4135-894e-99b7e324d09c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-e0a6-7185-8631-9388f1a7b054.webp",
      "image_media": {
        "alt_text": "Gazebo with picnic tables and barbecue grill in a grassy courtyard.",
        "public_id": "019e84a3-e0a6-7185-8631-9388f1a7b054",
        "storage_key": "property/6737460151191774/019e84a3-e0a6-7185-8631-9388f1a7b054.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the outdoors at our community picnic area, featuring a charming gazebo with ample seating and a barbecue grill, perfect for gatherings.",
      "link": "",
      "alt_text": "Gazebo with picnic tables and barbecue grill in a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f77071af-8cb9-40e9-b1ea-b48156960612",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-e7c4-7199-9dc0-bf54249b6f84.webp",
      "image_media": {
        "alt_text": "Building exterior with a sidewalk leading to the entrance and a leasing flag.",
        "public_id": "019e84a3-e7c4-7199-9dc0-bf54249b6f84",
        "storage_key": "property/6737460151191774/019e84a3-e7c4-7199-9dc0-bf54249b6f84.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to our apartment community. This exterior shot showcases the inviting entrance and well-maintained grounds.",
      "link": "",
      "alt_text": "Building exterior with a sidewalk leading to the entrance and a leasing flag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5880221d-8577-49d6-80fd-1b37dc882ef3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-e106-734d-892a-10f9c89c2ba6.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment building with covered walkways and balconies.",
        "public_id": "019e84a3-e106-734d-892a-10f9c89c2ba6",
        "storage_key": "property/6737460151191774/019e84a3-e106-734d-892a-10f9c89c2ba6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of apartment building featuring red brick facade, covered walkways, and private balconies. Ample parking is available, including accessible spaces.",
      "link": "",
      "alt_text": "Exterior of brick apartment building with covered walkways and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2573d79d-fcef-4568-96d8-e1d67c458051",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-e529-74aa-9955-b37247950599.webp",
      "image_media": {
        "alt_text": "Playground with slide and swings",
        "public_id": "019e84a3-e529-74aa-9955-b37247950599",
        "storage_key": "property/6737460151191774/019e84a3-e529-74aa-9955-b37247950599.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a slide and swings for children.",
      "link": "",
      "alt_text": "Playground with slide and swings",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_81cd157e-1fe4-4842-8955-2b21e6b2c9b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-e0f0-77df-835c-7454a0704a31.webp",
      "image_media": {
        "alt_text": "Sparkling blue outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e84a3-e0f0-77df-835c-7454a0704a31",
        "storage_key": "property/6737460151191774/019e84a3-e0f0-77df-835c-7454a0704a31.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with comfortable lounge chairs and scenic views of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "Sparkling blue outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f729178-dbd3-43b8-8cec-c6e88889d853",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-e6c0-728f-a3b8-043b57798f37.webp",
      "image_media": {
        "alt_text": "Adirondack chairs around a fire pit with a tennis court in the background.",
        "public_id": "019e84a3-e6c0-728f-a3b8-043b57798f37",
        "storage_key": "property/6737460151191774/019e84a3-e6c0-728f-a3b8-043b57798f37.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by the fire pit, or challenge a neighbor to a match on the tennis court. Enjoy all our community amenities.",
      "link": "",
      "alt_text": "Adirondack chairs around a fire pit with a tennis court in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7084103-756e-4f25-83f0-f097bdb3108a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-dca7-71bf-8a90-2becc9e8006b.webp",
      "image_media": {
        "alt_text": "Picnic table in front of a tennis court and apartment buildings.",
        "public_id": "019e84a3-dca7-71bf-8a90-2becc9e8006b",
        "storage_key": "property/6737460151191774/019e84a3-dca7-71bf-8a90-2becc9e8006b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a picnic table located conveniently near the tennis court and apartment buildings.",
      "link": "",
      "alt_text": "Picnic table in front of a tennis court and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_58e9d847-2a2b-4d95-80d2-a1e1922ff2bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-d765-7722-a2c9-e1c99e3e650d.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area at a multifamily property.",
        "public_id": "019e84a3-d765-7722-a2c9-e1c99e3e650d",
        "storage_key": "property/6737460151191774/019e84a3-d765-7722-a2c9-e1c99e3e650d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with ample lounge seating and a shaded cabana for ultimate relaxation. The perfect spot to unwind and soak up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered seating area at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3d7231b2-5cac-4cd8-a3fa-602954f5944d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-d3c6-723d-a356-99f08a804aaa.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, parking lot, and swimming pool.",
        "public_id": "019e84a3-d3c6-723d-a356-99f08a804aaa",
        "storage_key": "property/6737460151191774/019e84a3-d3c6-723d-a356-99f08a804aaa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious apartment complex featuring multiple buildings, ample parking, a refreshing swimming pool, and a tennis court, surrounded by lush greenery.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings, parking lot, and swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24deedb5-14c1-4096-a234-2a20363983e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-d59a-707f-a283-ee7cf0ae62e9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, two nightstands with lamps, and a ceiling fan.",
        "public_id": "019e84a3-d59a-707f-a283-ee7cf0ae62e9",
        "storage_key": "property/6737460151191774/019e84a3-d59a-707f-a283-ee7cf0ae62e9.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-sized bed, elegant nightstands with lamps, and a modern ceiling fan for optimal comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-sized bed, two nightstands with lamps, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e3e6ae3-afaa-42b1-a71c-d2fb8ceb8e40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-d22e-72ac-9334-f8b276ef0c99.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a parking lot and a car.",
        "public_id": "019e84a3-d22e-72ac-9334-f8b276ef0c99",
        "storage_key": "property/6737460151191774/019e84a3-d22e-72ac-9334-f8b276ef0c99.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment building with multiple levels and balconies, featuring a paved parking lot in front.",
      "link": "",
      "alt_text": "Apartment building exterior with a parking lot and a car.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_082a32ce-50d3-4d36-9d80-691b7b056ba4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e84a3-d1c5-7757-a175-4087dc41623a.webp",
      "image_media": {
        "alt_text": "Coffee station with a Keurig coffee maker, K-cup holder, tissues, and a wooden door.",
        "public_id": "019e84a3-d1c5-7757-a175-4087dc41623a",
        "storage_key": "property/6737460151191774/019e84a3-d1c5-7757-a175-4087dc41623a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee from our Keurig station, complete with K-cups, tissues, and hand sanitizer, conveniently located near the entrance.",
      "link": "",
      "alt_text": "Coffee station with a Keurig coffee maker, K-cup holder, tissues, and a wooden door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45ab2ab3-1f10-4a73-9fdc-1531d683819a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e16-077d-7648-b59b-d0cb6963d859.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel sink, and white cabinets.",
        "public_id": "019e1e16-077d-7648-b59b-d0cb6963d859",
        "storage_key": "property/6737460151191774/019e1e16-077d-7648-b59b-d0cb6963d859.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring granite countertops, a double stainless steel sink, and sleek white cabinetry, offering a clean and functional space.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel sink, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3791a971-e1d1-4d62-b89b-76f21a49d8ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e16-0810-7108-86ca-c73d6ec982dc.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, closet, and view into living room",
        "public_id": "019e1e16-0810-7108-86ca-c73d6ec982dc",
        "storage_key": "property/6737460151191774/019e1e16-0810-7108-86ca-c73d6ec982dc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a ceiling fan, ample closet space, and a connected living area. This room offers comfort and convenience.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, closet, and view into living room",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bb4a1ae-3902-4309-80d6-a19172776f0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e16-0793-74be-b664-2752ca78f94f.webp",
      "image_media": {
        "alt_text": "A well-lit living room with a sofa, coffee table, and armchair.",
        "public_id": "019e1e16-0793-74be-b664-2752ca78f94f",
        "storage_key": "property/6737460151191774/019e1e16-0793-74be-b664-2752ca78f94f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, a glass-top coffee table, and a stylish armchair. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "A well-lit living room with a sofa, coffee table, and armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bca80b5-2a08-4a5f-afbb-d099d2a4c001",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-cf55-70a1-bcb0-d50e3d72d88a.webp",
      "image_media": {
        "alt_text": "Community business center with a round table and chairs in the foreground, and computers and a printer in the background.",
        "public_id": "019e1e15-cf55-70a1-bcb0-d50e3d72d88a",
        "storage_key": "property/6737460151191774/019e1e15-cf55-70a1-bcb0-d50e3d72d88a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Utilize our convenient business center, complete with computers and a printer, for all your professional needs. Relax in the adjacent lounge area after.",
      "link": "",
      "alt_text": "Community business center with a round table and chairs in the foreground, and computers and a printer in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a021892a-86e7-42fd-bdf1-3ffa08a7e0eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "The Seahorse Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2301a Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Relaxed American eatery serving up breakfast, steaks & seafood, plus beer & wine.",
      "poi_long_description": "Relaxed American eatery serving up breakfast, steaks & seafood, plus beer & wine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-bbf5-769f-94de-93e87c049d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-bbf5-769f-94de-93e87c049d81",
        "storage_key": "property/6737460151191774/019e1e17-bbf5-769f-94de-93e87c049d81.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://seahorsesteakhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5691145686843123607&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-seahorse-restaurant",
      "poi_latitude": "35.60429999999999",
      "poi_longitude": "-77.40983299999999",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-758-6958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVEUTliVrokRl-dHZdkC-04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2da2d109-d9ab-40e6-8e9d-fcdfb62ed149",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Angus Grill West",
      "poi_type": "Restaurants",
      "poi_address": "2422 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Casual place whipping up burgers and other staples, plus a full bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c03a-73a8-80e6-c44f58985d72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c03a-73a8-80e6-c44f58985d72",
        "storage_key": "property/6737460151191774/019e1e17-c03a-73a8-80e6-c44f58985d72.webp",
        "width": 1280,
        "height": 732
      },
      "poi_business_url": "https://www.angusgrillnc.com/?utm_source=rsd&utm_medium=gmb&utm_campaign=brandawareness&utm_content=stantonsburg",
      "poi_directions_map_url": "https://maps.google.com/?cid=968382451269507846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "angus-grill-west",
      "poi_latitude": "35.6070597",
      "poi_longitude": "-77.4123666",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-757-7756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6zGzfNnprokRBhukbrVicA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_de554c23-3549-4389-8820-43cc64e54afa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "CPW'S Fine Food & Spirits",
      "poi_type": "Restaurants",
      "poi_address": "2422 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Convivial, casual Italian-American hangout with a bustling bar & rotating themed menus.",
      "poi_long_description": "Convivial, casual Italian-American hangout with a bustling bar & rotating themed menus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c1c3-774d-951f-75936d839627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c1c3-774d-951f-75936d839627",
        "storage_key": "property/6737460151191774/019e1e17-c1c3-774d-951f-75936d839627.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13153779316679234597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cpws-fine-food--spirits",
      "poi_latitude": "35.6071686",
      "poi_longitude": "-77.4123474",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-757-7756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-xJYpSjorokRJdSLyJici7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_eef22094-b5ac-46c6-aebd-7661362d0c6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "SPEEDY WOK",
      "poi_type": "Restaurants",
      "poi_address": "2434 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c3af-759e-a5d1-a36233fb58ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c3af-759e-a5d1-a36233fb58ae",
        "storage_key": "property/6737460151191774/019e1e17-c3af-759e-a5d1-a36233fb58ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://greenvillespeedywok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15579414504012343911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedy-wok",
      "poi_latitude": "35.6070975",
      "poi_longitude": "-77.4125172",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-364-8585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA--p9iXorokRZ2o5uPIyNdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_732286de-a829-4709-9c07-3543b00db8b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Hibachi Xpress",
      "poi_type": "Restaurants",
      "poi_address": "2414 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "This counter-serve joint offering hibachi-grilled entrees & bowls also has a modest sushi selection.",
      "poi_long_description": "This counter-serve joint offering hibachi-grilled entrees & bowls also has a modest sushi selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c60c-74af-ac2c-e5d576f43dd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c60c-74af-ac2c-e5d576f43dd7",
        "storage_key": "property/6737460151191774/019e1e17-c60c-74af-ac2c-e5d576f43dd7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hibachixpressofgreenville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14990077229141100394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hibachi-xpress",
      "poi_latitude": "35.6070072",
      "poi_longitude": "-77.41213259999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-752-7558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2W_zWy_orokRaoegrtFzB9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_22e7a7a0-e0ac-460e-a445-7eef9f6e6766",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Villa Verde DOS",
      "poi_type": "Restaurants",
      "poi_address": "2247 W Arlington Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "Counter-serve restaurant offering burritos, empanadas, and bowls, plus breakfast and vegetarian options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c27d-774b-8996-cffbdcdd0eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c27d-774b-8996-cffbdcdd0eb1",
        "storage_key": "property/6737460151191774/019e1e17-c27d-774b-8996-cffbdcdd0eb1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://myvillaverde.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11393768758704810629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "villa-verde-dos",
      "poi_latitude": "35.6072219",
      "poi_longitude": "-77.4115537",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-689-6005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_zjl29rprokRhSqLu1HMHp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_740d77e7-b9b9-411a-99f5-92bce2b8fb01",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Mi Cabana Mexican Restaurant #2",
      "poi_type": "Restaurants",
      "poi_address": "2231 W Arlington Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "Relaxed Mexican joint featuring tacos, fajitas, enchiladas and burritos plus a kids' menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-bb91-7159-93f9-7d4a00cb34a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-bb91-7159-93f9-7d4a00cb34a6",
        "storage_key": "property/6737460151191774/019e1e17-bb91-7159-93f9-7d4a00cb34a6.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "https://www.micabanarestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4257863397357207708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-cabana-mexican-restaurant-2",
      "poi_latitude": "35.6068555",
      "poi_longitude": "-77.4116763",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 252-931-9566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCehJ7yXorokRnECdZTP4Fjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9f699c16-487f-423b-b5e5-e1aba30ac00e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "20175 Arlington Blvd & K. W. Cafeteria",
      "poi_type": "Restaurants",
      "poi_address": "Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8650561910922266056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "20175-arlington-blvd--k-w-cafeteria",
      "poi_latitude": "35.599041",
      "poi_longitude": "-77.407692",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-1v553CrokRyMULsDn4DHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_d6610d12-877a-49b2-89b8-fb359e6f1588",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Hibachi Grill",
      "poi_type": "Restaurants",
      "poi_address": "3437 S Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "All-you-can-eat buffet offering Asian cuisine, including sushi, Chinese food, and hibachi chicken, plus vegetarian and vegan options. There's a salad bar and dessert, along with coffee and a good selection of teas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-bf73-777f-b1c4-64e76c1d400f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-bf73-777f-b1c4-64e76c1d400f",
        "storage_key": "property/6737460151191774/019e1e17-bf73-777f-b1c4-64e76c1d400f.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5222298480205705410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hibachi-grill",
      "poi_latitude": "35.5685194",
      "poi_longitude": "-77.4012139",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-321-8882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOU8do8LCrokRwjC5f8xUeUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_70adff61-f8a9-4770-9c4c-1b2eaddfccfc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Simply Delicious | Greek Mediterranean Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "327 E Arlington Blvd, Greenville, NC 27858, USA",
      "poi_short_description": "Straightforward eatery plating Mediterranean standards including hummus, kabobs and gyros.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c8de-77d5-ae6b-0f5d7835d958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c8de-77d5-ae6b-0f5d7835d958",
        "storage_key": "property/6737460151191774/019e1e17-c8de-77d5-ae6b-0f5d7835d958.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.simplydeliciousmediterranean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8669893150121815928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simply-delicious--greek-mediterranean-cuisine",
      "poi_latitude": "35.5869584",
      "poi_longitude": "-77.3716173",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-565-8168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QMuM4TdrokReG-ajeKlUXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_82170bc6-ccd3-42df-9837-ff4b0d7cd211",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Shogun | Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "420 E Arlington Blvd # F, Greenville, NC 27858, USA",
      "poi_short_description": "Roomy eatery & bar with an open kitchen turning out Japanese staples like sushi, hibachi & teriyaki.",
      "poi_long_description": "Roomy eatery & bar with an open kitchen turning out Japanese staples like sushi, hibachi & teriyaki.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c23e-71f6-90bc-88fbb26a5726.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c23e-71f6-90bc-88fbb26a5726",
        "storage_key": "property/6737460151191774/019e1e17-c23e-71f6-90bc-88fbb26a5726.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shogunnctogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9890445197827517945&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shogun--japanese-restaurant",
      "poi_latitude": "35.5843743",
      "poi_longitude": "-77.37005909999999",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 252-565-8818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSgxM07drokR-S36boHrQYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_aa5230d5-7b63-472f-a263-8a81c9f7f3f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Habibi Mediterranean Grill",
      "poi_type": "Restaurants",
      "poi_address": "310 E Arlington Blvd, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-c92f-73b1-b018-b7efcf743855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-c92f-73b1-b018-b7efcf743855",
        "storage_key": "property/6737460151191774/019e1e17-c92f-73b1-b018-b7efcf743855.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://habibimediterraneangrillgreenvillenc.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11206749110254714713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "habibi-mediterranean-grill",
      "poi_latitude": "35.5868149",
      "poi_longitude": "-77.37279900000001",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-364-1406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b47f5e0008bf",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b47f5e0008bf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu2szO__drokRWT-om_Behps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_40561953-68bf-4bd8-9dc5-6f4afea42b13",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "2460 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Chain offering a selection of produce (plus hot food, meats and baked goods) and employing friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d039-7299-bab0-b8fdc7afb4d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d039-7299-bab0-b8fdc7afb4d6",
        "storage_key": "property/6737460151191774/019e1e17-d039-7299-bab0-b8fdc7afb4d6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://stores.foodlion.com/nc/greenville/2460-stantonsburg-rd?y_source=1_NTA0NjY0OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16457681201881678206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.606859",
      "poi_longitude": "-77.413702",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 252-830-6259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab6e-74cf-acaa-04bdb36765c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab6e-74cf-acaa-04bdb36765c9",
        "storage_key": "property/6737460151191774/019e1e15-ab6e-74cf-acaa-04bdb36765c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c2asCjorokRfgHISNttZeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_89990222-aadc-49cd-b85c-5a0a3efe4365",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "2438 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-cbd7-756c-ae0b-3b73fc3bc057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-cbd7-756c-ae0b-3b73fc3bc057",
        "storage_key": "property/6737460151191774/019e1e17-cbd7-756c-ae0b-3b73fc3bc057.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2438+stantonsburg+rd-greenville-nc-27834/id=19173",
      "poi_directions_map_url": "https://maps.google.com/?cid=6256769012057078272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.607227",
      "poi_longitude": "-77.41275",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-758-5188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH55l8QzprokRAHpVRUSC1FY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ddeb5cc8-1a09-4204-a7bc-30ff30d4d797",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Speedway",
      "poi_type": "Shopping & Retail",
      "poi_address": "3000 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_long_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-cbeb-7345-b281-efbd52818e00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-cbeb-7345-b281-efbd52818e00",
        "storage_key": "property/6737460151191774/019e1e17-cbeb-7345-b281-efbd52818e00.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.speedway.com/locations/nc/greenville/3000-stantonsburg-road-44666?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16880568898631936514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway",
      "poi_latitude": "35.607069",
      "poi_longitude": "-77.4299137",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 252-695-6206",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e18-0774-72aa-a0ea-e1226682f522.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-0774-72aa-a0ea-e1226682f522",
        "storage_key": "property/6737460151191774/019e1e18-0774-72aa-a0ea-e1226682f522.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJL7XtHdTprokRAqp26fnTQ-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_3544882c-663c-46e9-877c-a68f0f90c932",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "3100 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-cfce-73d3-bc2c-2591f59a3112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-cfce-73d3-bc2c-2591f59a3112",
        "storage_key": "property/6737460151191774/019e1e17-cfce-73d3-bc2c-2591f59a3112.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/nc/greenville/24981",
      "poi_directions_map_url": "https://maps.google.com/?cid=6393021274289923206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.6061325",
      "poi_longitude": "-77.4304392",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 252-751-9516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2c-72cd-9bca-12c2bc9a69da",
        "storage_key": "property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMczXENTprokRhuSQL_qSuFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_348f29e0-ac23-41e2-83ac-9b40bf5dee59",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "210 Greenville Blvd SW, Greenville, NC 27834, USA",
      "poi_short_description": "Retail giant stocking grocery store items, toys, clothing, electronics, home goods, furniture and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d1c1-709f-b2cd-0f5ac0481593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d1c1-709f-b2cd-0f5ac0481593",
        "storage_key": "property/6737460151191774/019e1e17-d1c1-709f-b2cd-0f5ac0481593.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1379-greenville-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11688352857176849568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.5774237",
      "poi_longitude": "-77.3875071",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-355-2441",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2c-72cd-9bca-12c2bc9a69da",
        "storage_key": "property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgaXB57fCrokRoLxy_f5eNaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_19e8588e-af4c-4aa1-94ed-a05ff0ffa1e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greenville Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "714 Greenville Blvd SE, Greenville, NC 27858, USA",
      "poi_short_description": "Long-standing enclosed shopping center featuring 58 stores & restaurants under 1 roof.",
      "poi_long_description": "Long-standing enclosed shopping center featuring 58 stores & restaurants under 1 roof.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-7ae9-76b9-948c-a4aded93dacd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-7ae9-76b9-948c-a4aded93dacd",
        "storage_key": "property/6737460151191774/019e1e15-7ae9-76b9-948c-a4aded93dacd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thegreenvillemall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5262191077716969931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-mall",
      "poi_latitude": "35.5860817",
      "poi_longitude": "-77.3677381",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-756-5234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2c-72cd-9bca-12c2bc9a69da",
        "storage_key": "property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf6nDblDdrokRy8mMp-cOB0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_48eab53f-0d13-4dc5-95f6-548e188941e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3140 Evans St, Greenville, NC 27834, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d238-7550-92fd-aa296e1f2770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d238-7550-92fd-aa296e1f2770",
        "storage_key": "property/6737460151191774/019e1e17-d238-7550-92fd-aa296e1f2770.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/nc/greenville/3140-evans-st-386.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2106913530959548508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "35.574496",
      "poi_longitude": "-77.38475199999999",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-321-4984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2c-72cd-9bca-12c2bc9a69da",
        "storage_key": "property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH8kjd8rCrokRXNBOibFCPR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_897c67ab-75b3-4df5-be07-290d300d55d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3040 Evans St, Greenville, NC 27834, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d413-71c5-81c7-bb8cf774ca89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d413-71c5-81c7-bb8cf774ca89",
        "storage_key": "property/6737460151191774/019e1e17-d413-71c5-81c7-bb8cf774ca89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/greenville/1022",
      "poi_directions_map_url": "https://maps.google.com/?cid=10385686962230836328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.5790193",
      "poi_longitude": "-77.38359679999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-355-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2c-72cd-9bca-12c2bc9a69da",
        "storage_key": "property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyx52WLTCrokRaLwsNERfIZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4f791b58-acf5-4346-94d8-6b1ad112162d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Country Side Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "4724 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12094345176181197185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-side-store",
      "poi_latitude": "35.6051641",
      "poi_longitude": "-77.4834039",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 252-321-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e18-0756-765d-8e5d-f9ee5f36748b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-0756-765d-8e5d-f9ee5f36748b",
        "storage_key": "property/6737460151191774/019e1e18-0756-765d-8e5d-f9ee5f36748b.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJGfFOGePBrokRgUk98du-16c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_334b501f-b347-4cfe-87d8-bdc2a142fbfb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Lakeforest Elementary School",
      "poi_type": "Education",
      "poi_address": "3300 Briarcliff Dr, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pitt.k12.nc.us/lakeforest",
      "poi_directions_map_url": "https://maps.google.com/?cid=8449136913806111067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeforest-elementary-school",
      "poi_latitude": "35.5923311",
      "poi_longitude": "-77.4213407",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 252-756-3941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaxZdNobCrokRW7EN9kFdQXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_516c6640-f9ca-49b0-a126-74f2162c3463",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Falkland Elementary School",
      "poi_type": "Education",
      "poi_address": "503 NC-121, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pitt.k12.nc.us/falkland",
      "poi_directions_map_url": "https://maps.google.com/?cid=8260658993703934909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "falkland-elementary-school",
      "poi_latitude": "35.6696853",
      "poi_longitude": "-77.4875793",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-752-7820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa6SMjwborokRvdtbgpbBo3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_aea70aa0-19a3-4bbc-a5fa-7b26f1bc8943",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Wahl-Coates Elementary School",
      "poi_type": "Education",
      "poi_address": "2200 E 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pitt.k12.nc.us/wahlcoates",
      "poi_directions_map_url": "https://maps.google.com/?cid=3166099364914690741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wahl-coates-elementary-school",
      "poi_latitude": "35.6062718",
      "poi_longitude": "-77.34923500000001",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 252-752-2514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp9B06pHnrokRtXpUAZk-8Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ffa65bfb-2778-4819-aeed-5e296c680a14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "J.H. Rose High School",
      "poi_type": "Education",
      "poi_address": "600 W Arlington Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d1e7-76b8-bd83-40611d88ce63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d1e7-76b8-bd83-40611d88ce63",
        "storage_key": "property/6737460151191774/019e1e17-d1e7-76b8-bd83-40611d88ce63.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.pitt.k12.nc.us/jhr",
      "poi_directions_map_url": "https://maps.google.com/?cid=2235126104135116370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jh-rose-high-school",
      "poi_latitude": "35.593733",
      "poi_longitude": "-77.3841279",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-321-3640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj7VwVKnCrokRUiYteVnDBB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_37a571a7-2549-402a-9930-9655c480b67d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "D.H. Conley High School",
      "poi_type": "Education",
      "poi_address": "2006 Worthington Rd, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d4f6-747c-a671-3c43a555a64d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d4f6-747c-a671-3c43a555a64d",
        "storage_key": "property/6737460151191774/019e1e17-d4f6-747c-a671-3c43a555a64d.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.pitt.k12.nc.us/dhc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1509483648374872885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dh-conley-high-school",
      "poi_latitude": "35.5303639",
      "poi_longitude": "-77.3247248",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 252-756-3440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb-B7WlzcrokRNRulb2HD8hQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f4e3aefa-45ad-4243-967e-6a62c59534c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "South Central High School",
      "poi_type": "Education",
      "poi_address": "570 Forlines Rd, Winterville, NC 28590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d5c4-709d-9948-814a785f7049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d5c4-709d-9948-814a785f7049",
        "storage_key": "property/6737460151191774/019e1e17-d5c4-709d-9948-814a785f7049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pitt.k12.nc.us/schs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13475331752653991778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-central-high-school",
      "poi_latitude": "35.5415155",
      "poi_longitude": "-77.42862579999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-321-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjbeTXKHDrokRYq97a9X-Abs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_04055209-98e6-4641-ba78-8225d201e1a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "East Carolina University",
      "poi_type": "Education",
      "poi_address": "E 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-7db3-72a7-909a-8ec1114808a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-7db3-72a7-909a-8ec1114808a0",
        "storage_key": "property/6737460151191774/019e1e15-7db3-72a7-909a-8ec1114808a0.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "https://www.ecu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5924483534454368571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-carolina-university",
      "poi_latitude": "35.6068806",
      "poi_longitude": "-77.3665364",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-328-6131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBxZ44pbnrokRO6nNpGL-N1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_18b848b4-5904-42e8-a06e-55b9fd62d1c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Pitt Community College",
      "poi_type": "Education",
      "poi_address": "1986 Pitt Tech Rd, Winterville, NC 28590, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-8165-709c-9e7d-91f28ec88709.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-8165-709c-9e7d-91f28ec88709",
        "storage_key": "property/6737460151191774/019e1e15-8165-709c-9e7d-91f28ec88709.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pittcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13604648377313597505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-community-college",
      "poi_latitude": "35.5495599",
      "poi_longitude": "-77.4068149",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-493-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3Uc-zubCrokRQRjfX55rzbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9f05343f-687d-469d-8e33-0291e7572741",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Children's Campus of Greenville",
      "poi_type": "Education",
      "poi_address": "1433 E Fire Tower Rd, Greenville, NC 27858, USA",
      "poi_short_description": "Caring pre-school for infants, toddlers and pre-K kids, with outdoor play, gardening areas and play-learning activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d62b-729e-9dc3-ee3b42a4a041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d62b-729e-9dc3-ee3b42a4a041",
        "storage_key": "property/6737460151191774/019e1e17-d62b-729e-9dc3-ee3b42a4a041.webp",
        "width": 1280,
        "height": 866
      },
      "poi_business_url": "https://childrenscampusgreenville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12315354440450020849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-campus-of-greenville",
      "poi_latitude": "35.5638278",
      "poi_longitude": "-77.3628323",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 252-756-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFx9ENzvdrokR8ZUNMp3t6Ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_2ec9d75f-2439-478f-9cd1-9addcfd30f10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Saint Peter Catholic School",
      "poi_type": "Education",
      "poi_address": "2606 E 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-d98e-760b-a80b-cd2dd94ecefb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-d98e-760b-a80b-cd2dd94ecefb",
        "storage_key": "property/6737460151191774/019e1e17-d98e-760b-a80b-cd2dd94ecefb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.stpeterscatholicschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4660969100210838915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-peter-catholic-school",
      "poi_latitude": "35.6068902",
      "poi_longitude": "-77.3434888",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 252-752-3529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH-Eie5rnrokRg50jp7MWr0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8cc941f8-e194-4d8a-b715-50d7e855c566",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "River Park North",
      "poi_type": "Entertainment",
      "poi_address": "1000 Mumford Rd, Greenville, NC 27834, USA",
      "poi_short_description": "324-acre parkland offering 5 fishing ponds, 2 piers, campsites, boat rentals, trails & picnic areas.",
      "poi_long_description": "324-acre parkland offering 5 fishing ponds, 2 piers, campsites, boat rentals, trails & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-9872-75c3-b378-bf935cf6d57f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-9872-75c3-b378-bf935cf6d57f",
        "storage_key": "property/6737460151191774/019e1e15-9872-75c3-b378-bf935cf6d57f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.greenvillenc.gov/government/recreation-parks/river-park-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=13168882477249410174&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-park-north",
      "poi_latitude": "35.6280096",
      "poi_longitude": "-77.35975239999999",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-329-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY7i2Q8jnrokRfjRRYddEwbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a649d7f0-d1dc-4e0a-bf27-803faadb3b00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greenville Toyota Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "105 E 1st St, Greenville, NC 27858, USA",
      "poi_short_description": "Stage suitable for concerts and other performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-db76-777e-9cd0-4317fb89bd3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-db76-777e-9cd0-4317fb89bd3f",
        "storage_key": "property/6737460151191774/019e1e17-db76-777e-9cd0-4317fb89bd3f.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=108866583846226813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-toyota-amphitheater",
      "poi_latitude": "35.6161525",
      "poi_longitude": "-77.37017089999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ04cIDOfnrokRfYsQypTFggE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_39d29dbd-785a-4426-ba23-5b0184a96640",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "The State Theatre",
      "poi_type": "Entertainment",
      "poi_address": "110 W 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "Space hosting concerts and shows from a variety of acts, with balcony seats and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-db87-734f-983b-80feaa50032b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-db87-734f-983b-80feaa50032b",
        "storage_key": "property/6737460151191774/019e1e17-db87-734f-983b-80feaa50032b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.statetheatrenc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4085649419415329253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-state-theatre",
      "poi_latitude": "35.6115134",
      "poi_longitude": "-77.3736006",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK31741vnrokR5RkIEYAkszg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_2ad6c278-d545-44cb-a0e1-d0a88e141f38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greenville Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "802 Evans St, Greenville, NC 27834, USA",
      "poi_short_description": "Free museum building featuring local, regional and national art exhibits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-89f5-7478-b54f-a4e2c2703bf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-89f5-7478-b54f-a4e2c2703bf0",
        "storage_key": "property/6737460151191774/019e1e15-89f5-7478-b54f-a4e2c2703bf0.webp",
        "width": 800,
        "height": 449
      },
      "poi_business_url": "https://www.gmoa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2609222515371182819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-museum-of-art",
      "poi_latitude": "35.6079879",
      "poi_longitude": "-77.3741574",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-758-1946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab29-77ae-92c5-fcdbc1aaf3ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab29-77ae-92c5-fcdbc1aaf3ae",
        "storage_key": "property/6737460151191774/019e1e15-ab29-77ae-92c5-fcdbc1aaf3ae.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJK0-1N-PnrokR44qmsA3SNSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7fa8b42a-6085-4635-ba2c-5403b0683abd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "AMC Fire Tower 12",
      "poi_type": "Entertainment",
      "poi_address": "1685 E Fire Tower Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-de59-70d0-a434-7bbdfa34f6c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-de59-70d0-a434-7bbdfa34f6c8",
        "storage_key": "property/6737460151191774/019e1e17-de59-70d0-a434-7bbdfa34f6c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/greenville-nc/amc-fire-tower-12?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17393828229078499113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-fire-tower-12",
      "poi_latitude": "35.5664768",
      "poi_longitude": "-77.3612586",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 252-353-4991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e18-076b-72ad-a2f9-7ad8bf43ecc2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-076b-72ad-a2f9-7ad8bf43ecc2",
        "storage_key": "property/6737460151191774/019e1e18-076b-72ad-a2f9-7ad8bf43ecc2.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUE7hzvdrokRKb9iLp5KY_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b0b59a67-2a4c-48fe-82b9-a6ada72ba550",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Pitt Street Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "630 S Pitt St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e345-769b-a8a1-13bedc101acb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e345-769b-a8a1-13bedc101acb",
        "storage_key": "property/6737460151191774/019e1e17-e345-769b-a8a1-13bedc101acb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pittstreetbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15729044209721479871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-street-brewing-company",
      "poi_latitude": "35.609393",
      "poi_longitude": "-77.37712739999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-227-4151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWlilOLnrokRvxLdaF_KSNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_ec45c4bd-0211-4ae1-aafc-248c17eecf49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Wright Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "100 Founders Dr, Greenville, NC 27858, USA",
      "poi_short_description": "Venue for performing arts hosting productions like \"The Nutcracker\".",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e052-73ee-af36-15b60974aa41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e052-73ee-af36-15b60974aa41",
        "storage_key": "property/6737460151191774/019e1e17-e052-73ee-af36-15b60974aa41.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://studentcenters.ecu.edu/wright/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9160372933756941822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wright-auditorium",
      "poi_latitude": "35.6070621",
      "poi_longitude": "-77.3646431",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-328-4731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSRE60u_nrokR_nWvRqYuIH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_95bb3a7f-87af-44fd-9649-573295e7a10b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "School of Art and Design, East Carolina University",
      "poi_type": "Entertainment",
      "poi_address": "The Leo W. Jenkins Fine Arts Center, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e0fa-766d-9edf-4c6f2ffd4825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e0fa-766d-9edf-4c6f2ffd4825",
        "storage_key": "property/6737460151191774/019e1e17-e0fa-766d-9edf-4c6f2ffd4825.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://art.ecu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7906748349514478406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "school-of-art-and-design-east-carolina-university",
      "poi_latitude": "35.6088934",
      "poi_longitude": "-77.3681545",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-328-6665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJecTgceXnrokRRnM3bbtpum0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_df4223fb-4ee0-4e8f-80ae-e8ab91340fdb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Emerge Gallery & Art Center",
      "poi_type": "Entertainment",
      "poi_address": "404 Evans St, Greenville, NC 27858, USA",
      "poi_short_description": "Nonprofit organization with art galleries, classes, pottery studios and summer camps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-dff4-7268-a216-fc29de9dff47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-dff4-7268-a216-fc29de9dff47",
        "storage_key": "property/6737460151191774/019e1e17-dff4-7268-a216-fc29de9dff47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.emergegallery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17110577991267321663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emerge-gallery--art-center",
      "poi_latitude": "35.6119814",
      "poi_longitude": "-77.3730308",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-551-6947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyV49-PnrokRPwcb_wb8dO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_f510aab0-e184-44de-8cd1-8b15a05fbce2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "ECU Health Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2100 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-9544-7786-aadf-e77246815e7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-9544-7786-aadf-e77246815e7f",
        "storage_key": "property/6737460151191774/019e1e15-9544-7786-aadf-e77246815e7f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://locations.ecuhealth.org/Details/163",
      "poi_directions_map_url": "https://maps.google.com/?cid=4684740979372181751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-health-medical-center",
      "poi_latitude": "35.6082626",
      "poi_longitude": "-77.4014852",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-847-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab7a-73fa-a9f1-936a41c71dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab7a-73fa-a9f1-936a41c71dad",
        "storage_key": "property/6737460151191774/019e1e15-ab7a-73fa-a9f1-936a41c71dad.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz40sCPorokR98gxlBmLA0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_e352937b-4d1d-4d29-9e8e-30801a29a90d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "ECU Health Immediate Care - Greenville",
      "poi_type": "Health and Wellness",
      "poi_address": "2460 Emerald Pl, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.ecuhealth.org/Details/138206",
      "poi_directions_map_url": "https://maps.google.com/?cid=5041444902105225609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-health-immediate-care---greenville",
      "poi_latitude": "35.6012793",
      "poi_longitude": "-77.40838029999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-830-2021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-d1Ld4TprokRiZmvgG3P9kU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b6325750-1b94-4675-a664-330fbff2d097",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "704 S Memorial Dr, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e3c7-7149-8306-b51f56b8133a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e3c7-7149-8306-b51f56b8133a",
        "storage_key": "property/6737460151191774/019e1e17-e3c7-7149-8306-b51f56b8133a.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/greenville-nc-pharmacies/704-so-memorial-dr-greenville-nc-27834/storeid=3385?WT.mc_id=LS_GOOGLE_RX_3385",
      "poi_directions_map_url": "https://maps.google.com/?cid=15264264211538715707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.6068698",
      "poi_longitude": "-77.39584769999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 252-758-4104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e18-076c-74cd-ab50-4ec239d071cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-076c-74cd-ab50-4ec239d071cf",
        "storage_key": "property/6737460151191774/019e1e18-076c-74cd-ab50-4ec239d071cf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4NY_xDorokROyR5Rm2P1dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c914f340-5517-429a-afcb-c83b0f684323",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "ECU Health Wellness Center - Greenville",
      "poi_type": "Health and Wellness",
      "poi_address": "2610 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.ecuhealth.org/Details/402",
      "poi_directions_map_url": "https://maps.google.com/?cid=13612762658839317119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-health-wellness-center---greenville",
      "poi_latitude": "35.6076297",
      "poi_longitude": "-77.41797869999999",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 252-847-6501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Z3gNHvprokRf8rRw4M_6rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "custom_016df5eb-96c2-467a-ab50-0fbe55c45c99",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greenville Aquatics & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "921 Staton Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Casual gym featuring an indoor pool, plus a basketball court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-93e8-76af-9fb1-97e4e09fade6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-93e8-76af-9fb1-97e4e09fade6",
        "storage_key": "property/6737460151191774/019e1e15-93e8-76af-9fb1-97e4e09fade6.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.greenvillenc.gov/288/Aquatics-Fitness-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=16638453349469266147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-aquatics--fitness-center",
      "poi_latitude": "35.65333800000001",
      "poi_longitude": "-77.350516",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-329-4041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQT1LpUbmrokR4yAGwyqp5-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9938b793-d59b-4403-bd39-1f00299524e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "CrossFit Greenville",
      "poi_type": "Health and Wellness",
      "poi_address": "818 Clark St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e5ad-7638-83f6-8fcde97a5d11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e5ad-7638-83f6-8fcde97a5d11",
        "storage_key": "property/6737460151191774/019e1e17-e5ad-7638-83f6-8fcde97a5d11.webp",
        "width": 960,
        "height": 687
      },
      "poi_business_url": "http://crossfitgreenville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2960201479779844414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-greenville",
      "poi_latitude": "35.608591",
      "poi_longitude": "-77.37844199999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-756-4790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJayrnOqnCrokRPgHd4Y-_FCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6daab1dd-d868-4276-b343-7b5fab685a30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "420 E Arlington Blvd Suite J, Greenville, NC 27858, USA",
      "poi_short_description": "Fitness studio offering low-impact, high-intensity workouts inspired by ballet, yoga, and Pilates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e5c2-708f-9164-bdcad31f30c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e5c2-708f-9164-bdcad31f30c8",
        "storage_key": "property/6737460151191774/019e1e17-e5c2-708f-9164-bdcad31f30c8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/greenville-nc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14181571542052648261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "35.5840914",
      "poi_longitude": "-77.3699117",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-689-6103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ89dSk7drokRRTXWKC4Qz8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_5ccd8e57-d78b-4378-ae8f-f0cde5ace39a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Town Common",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "105 E 1st St, Greenville, NC 27858, USA",
      "poi_short_description": "City park with a modern playground, riverfront esplanade, open-air amphitheater & boat ramp.",
      "poi_long_description": "City park with a modern playground, riverfront esplanade, open-air amphitheater & boat ramp.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-9ce9-71aa-a2de-9f2a2fe332e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-9ce9-71aa-a2de-9f2a2fe332e6",
        "storage_key": "property/6737460151191774/019e1e15-9ce9-71aa-a2de-9f2a2fe332e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/62/251?npage=4",
      "poi_directions_map_url": "https://maps.google.com/?cid=11698650257115329890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "town-common",
      "poi_latitude": "35.6152917",
      "poi_longitude": "-77.36927779999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_hjIufnrokRYjXkPm30WaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_663bf26f-d069-40d0-a9d5-f8b4a1844321",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "South Tar River Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Greenway, Greenville, NC 27858, USA",
      "poi_short_description": "Winding park pathway offering walking, jogging & biking in a natural setting near the river.",
      "poi_long_description": "Winding park pathway offering walking, jogging & biking in a natural setting near the river.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-ea11-71ce-b272-0486ee972c4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-ea11-71ce-b272-0486ee972c4f",
        "storage_key": "property/6737460151191774/019e1e17-ea11-71ce-b272-0486ee972c4f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.greenvillenc.gov/government/recreation-parks/greenville-greenways",
      "poi_directions_map_url": "https://maps.google.com/?cid=4082442651470898847&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-tar-river-greenway",
      "poi_latitude": "35.61380550000001",
      "poi_longitude": "-77.34213369999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKRHutZbnrokRn6bTOPa_pzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7a2ed887-dfb4-40bc-be78-2e1771193f6a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greensprings Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 E 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e7d7-71fa-b778-ae3962ca526c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e7d7-71fa-b778-ae3962ca526c",
        "storage_key": "property/6737460151191774/019e1e17-e7d7-71fa-b778-ae3962ca526c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/20/251?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=13321115421044859403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greensprings-park",
      "poi_latitude": "35.6053757",
      "poi_longitude": "-77.3437448",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJReAcnUjnrokRC2Jbq-Ub3rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4711dca6-366a-47c8-99f5-6b0c2faa644e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greenville Offleash Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "200 N Ash St, Greenville, NC 27858, USA",
      "poi_short_description": "Large grassy area for dogs to run and play, with picnic tables and a water spigot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-ed78-7285-a428-6914e458514f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-ed78-7285-a428-6914e458514f",
        "storage_key": "property/6737460151191774/019e1e17-ed78-7285-a428-6914e458514f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/54/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5418804516701890816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-offleash-dog-park",
      "poi_latitude": "35.6134922",
      "poi_longitude": "-77.3550589",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfy58I5XnrokRAGlMdf91M0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_036be6e0-a011-4003-9fc0-cf4f26f0f8cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "The Walter L. Stasavich Science and Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Mumford Rd, Greenville, NC 27834, USA",
      "poi_short_description": "Learning facility housing a 10,000-gallon freshwater aquarium, wildlife dioramas & a touch tank.",
      "poi_long_description": "Learning facility housing a 10,000-gallon freshwater aquarium, wildlife dioramas & a touch tank.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-e8e8-731d-bb93-8039089182ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-e8e8-731d-bb93-8039089182ab",
        "storage_key": "property/6737460151191774/019e1e17-e8e8-731d-bb93-8039089182ab.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.greenvillenc.gov/government/recreation-parks/river-park-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=1020461537157865856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-walter-l-stasavich-science-and-nature-center",
      "poi_latitude": "35.628035",
      "poi_longitude": "-77.36013299999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-329-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yuQpMjnrokRgGE-hVxoKQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_d8c883dd-b34b-498c-8752-1a84112688d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Wildwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3450 Blue Heron Dr, Greenville, NC 27834, USA",
      "poi_short_description": "New park offering kayaking, trails and boating, plus playground equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-9b53-74d8-a5fc-b782ec7989d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-9b53-74d8-a5fc-b782ec7989d2",
        "storage_key": "property/6737460151191774/019e1e15-9b53-74d8-a5fc-b782ec7989d2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillenc.gov/Facilities/Facility/Details/Wildwood-Park-44",
      "poi_directions_map_url": "https://maps.google.com/?cid=16635169238969805013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildwood-park",
      "poi_latitude": "35.6144646",
      "poi_longitude": "-77.3221162",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 252-329-4789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9BErv7nrokR1ehMM0n-2-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_33c0efe9-005f-413b-a548-f91099baa358",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Elm Street Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1055 S Elm St, Greenville, NC 27858, USA",
      "poi_short_description": "Expansive community park boasting a lighted youth ball field, tennis courts & picnic areas.",
      "poi_long_description": "Expansive community park boasting a lighted youth ball field, tennis courts & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-99c8-77b2-84b5-352b15f90003.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-99c8-77b2-84b5-352b15f90003",
        "storage_key": "property/6737460151191774/019e1e15-99c8-77b2-84b5-352b15f90003.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.greenvillenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10184049553228629806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elm-street-park",
      "poi_latitude": "35.6010292",
      "poi_longitude": "-77.358538",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 252-329-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGypsXYLnrokRLgcrexwDVY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9bf80045-d91b-4fbb-9187-61c693f6e540",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "West Meadowbrook Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Legion St, Greenville, NC 27834, USA",
      "poi_short_description": "Relaxed park with a baseball field, a playground, and a disc golf course.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f224-7602-94bf-35d42888604e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f224-7602-94bf-35d42888604e",
        "storage_key": "property/6737460151191774/019e1e17-f224-7602-94bf-35d42888604e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillenc.gov/Home/Components/FacilityDirectory/FacilityDirectory/63",
      "poi_directions_map_url": "https://maps.google.com/?cid=2569492675014227142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-meadowbrook-park",
      "poi_latitude": "35.6274259",
      "poi_longitude": "-77.37708669999999",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-329-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2e-7040-b05a-b90839056419",
        "storage_key": "property/6737460151191774/019e1e15-ab2e-7040-b05a-b90839056419.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwbDY9jnrokRxvQwY_mrqCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d2d0701a-b23f-4b0f-8872-a375438c1bad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Leroy James Farmers Market",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4560 County Home Rd, Greenville, NC 27858, USA",
      "poi_short_description": "Indoor seasonal market for local goods, including fresh produce and honey.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f184-74ee-a41d-4c3cfc062cd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f184-74ee-a41d-4c3cfc062cd8",
        "storage_key": "property/6737460151191774/019e1e17-f184-74ee-a41d-4c3cfc062cd8.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.pittcountync.gov/599/Farmers-Market",
      "poi_directions_map_url": "https://maps.google.com/?cid=1720941259356742744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leroy-james-farmers-market",
      "poi_latitude": "35.5490906",
      "poi_longitude": "-77.3513598",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 252-714-8198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab2c-72cd-9bca-12c2bc9a69da",
        "storage_key": "property/6737460151191774/019e1e15-ab2c-72cd-9bca-12c2bc9a69da.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3clFk-HcrokRWKRFG_UC4hc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farmers_market"
    },
    {
      "id": "custom_4c8fdc45-8bd6-4698-9540-37449fe9ccd6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "G.K. Butterfield Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "600 S Pitt St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f104-761b-a849-6c7b5b7c82f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f104-761b-a849-6c7b5b7c82f8",
        "storage_key": "property/6737460151191774/019e1e17-f104-761b-a849-6c7b5b7c82f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greenvillenc.gov/government/public-works/major-projects/g-k-butterfield-transportation-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=3298844270051507652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gk-butterfield-transportation-center",
      "poi_latitude": "35.6107129",
      "poi_longitude": "-77.37669799999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-329-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLe1EevjnrokRxL3AtWLZxy0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_e6e2e067-7705-431e-bc2d-83d72bf0701d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Pitt-Greenville Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 Airport Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-9fa3-748f-8d5e-358cfb8dc971.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e15-9fa3-748f-8d5e-358cfb8dc971",
        "storage_key": "property/6737460151191774/019e1e15-9fa3-748f-8d5e-358cfb8dc971.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.flypgv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6646301192363862710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-greenville-airport",
      "poi_latitude": "35.6338958",
      "poi_longitude": "-77.3812179",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-902-2025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-adb3-7130-9d45-eddef1ca2801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-adb3-7130-9d45-eddef1ca2801",
        "storage_key": "property/6737460151191774/019e1e15-adb3-7130-9d45-eddef1ca2801.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8yAKN9bnrokRtmoaibhnPFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e1fe6ba9-b20c-4aaa-ba59-5b7d7acfa7b4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greenville Area Transit Transfer Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "600 S Pitt St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.greenvillenc.gov/government/public-works/great-bus-system/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=9628704861440376924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-area-transit-transfer-center",
      "poi_latitude": "35.6107129",
      "poi_longitude": "-77.37669799999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 252-329-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyA9OhLDrokRXAA7cQ4IoIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b654a6bd-4cf7-4d6b-b16f-bcb6d975e5fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Parking and Transportation Services",
      "poi_type": "Transportation & Transit",
      "poi_address": "Parking and Transportation Services, 305 E 10th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f169-7195-8f4f-b2570744097b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f169-7195-8f4f-b2570744097b",
        "storage_key": "property/6737460151191774/019e1e17-f169-7195-8f4f-b2570744097b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parking.ecu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7203798766727832781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parking-and-transportation-services",
      "poi_latitude": "35.605889",
      "poi_longitude": "-77.37117889999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-328-6294",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3eMP_vnrokRzaQ1nM8I-WM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_f1d2aaa3-5be0-43b5-9121-1e3c532417c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Wilson, NC",
      "poi_type": "Transportation & Transit",
      "poi_address": "401 Nash St, Wilson, NC 27893, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f5b4-7520-9f82-19008b970326.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f5b4-7520-9f82-19008b970326",
        "storage_key": "property/6737460151191774/019e1e17-f5b4-7520-9f82-19008b970326.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WLN",
      "poi_directions_map_url": "https://maps.google.com/?cid=11298939027127963152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilson-nc",
      "poi_latitude": "35.72317049999999",
      "poi_longitude": "-77.9078771",
      "poi_miles_from_property": "32",
      "poi_walking_minutes": "11 hours 37 mins",
      "poi_biking_minutes": "2 hours 54 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e18-0773-726a-9628-d2ace9f99c16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e18-0773-726a-9628-d2ace9f99c16",
        "storage_key": "property/6737460151191774/019e1e18-0773-726a-9628-d2ace9f99c16.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfF8dBOerokREI7CSi7lzZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_d8f745d9-b8f2-43f1-9758-e46f8931ed1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Stantonsburg Road Recycling",
      "poi_type": "Transportation & Transit",
      "poi_address": "3701 Stantonsburg Rd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f671-7717-a88a-94b87e965b58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f671-7717-a88a-94b87e965b58",
        "storage_key": "property/6737460151191774/019e1e17-f671-7717-a88a-94b87e965b58.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16022453035354187877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stantonsburg-road-recycling",
      "poi_latitude": "35.6000446",
      "poi_longitude": "-77.4411672",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 252-830-3864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab3c-7529-b021-7151836afe9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab3c-7529-b021-7151836afe9d",
        "storage_key": "property/6737460151191774/019e1e15-ab3c-7529-b021-7151836afe9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2X77XfCrokRZWiqIiUwW94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_a01e0a58-a757-42c0-92c6-5c4d101282b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "ECU Brody School of Medicine",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 Moye Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f7b6-776e-92a1-17dc8ebd14af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f7b6-776e-92a1-17dc8ebd14af",
        "storage_key": "property/6737460151191774/019e1e17-f7b6-776e-92a1-17dc8ebd14af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://medicine.ecu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4537742115236822215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ecu-brody-school-of-medicine",
      "poi_latitude": "35.6097321",
      "poi_longitude": "-77.4028507",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-328-6131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab77-7752-9917-8a2588bbea92",
        "storage_key": "property/6737460151191774/019e1e15-ab77-7752-9917-8a2588bbea92.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbVM-gxjorokRxzwFbWlM-T4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_08df764c-bc74-4ffc-9499-bfc71d8ddd83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Pitt County Government",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1717 W 5th St #1601, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-f85f-75dc-acea-4d0a58e5e049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-f85f-75dc-acea-4d0a58e5e049",
        "storage_key": "property/6737460151191774/019e1e17-f85f-75dc-acea-4d0a58e5e049.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pittcountync.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9318982125478241845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitt-county-government",
      "poi_latitude": "35.611701",
      "poi_longitude": "-77.39914379999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-902-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab3c-7529-b021-7151836afe9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab3c-7529-b021-7151836afe9d",
        "storage_key": "property/6737460151191774/019e1e15-ab3c-7529-b021-7151836afe9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-42-VRborokRNWZYed6sU4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_75caef18-135f-4931-8e1e-9ac0a1404506",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "City of Greenville, NC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 W 5th St, Greenville, NC 27858, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-fa56-758c-b551-98a2c3c8399b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-fa56-758c-b551-98a2c3c8399b",
        "storage_key": "property/6737460151191774/019e1e17-fa56-758c-b551-98a2c3c8399b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.greenvillenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14873217373618047209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-greenville-nc",
      "poi_latitude": "35.6115457",
      "poi_longitude": "-77.37436029999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-329-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab3c-7529-b021-7151836afe9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab3c-7529-b021-7151836afe9d",
        "storage_key": "property/6737460151191774/019e1e15-ab3c-7529-b021-7151836afe9d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0FwuOPnrokR6QisTWZIaM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_a731f3d3-7f78-41f8-9d67-6c89ee239e34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Greenville Utilities Commission",
      "poi_type": "Major Employers & Offices",
      "poi_address": "401 S Greene St, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-fbf4-772e-91f7-8fb3efaed5ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-fbf4-772e-91f7-8fb3efaed5ba",
        "storage_key": "property/6737460151191774/019e1e17-fbf4-772e-91f7-8fb3efaed5ba.webp",
        "width": 1280,
        "height": 986
      },
      "poi_business_url": "https://www.guc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=757033052474017965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greenville-utilities-commission",
      "poi_latitude": "35.61211249999999",
      "poi_longitude": "-77.3743886",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 252-752-7166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYy-m2U3drokRrYjx34yFgQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_78ccf49a-1c72-48fc-8384-5bec13e1ddcd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Thermo Fisher Scientific",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5900 M.L.K. Jr Hwy, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-ff75-7656-a65a-aae77095eb40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-ff75-7656-a65a-aae77095eb40",
        "storage_key": "property/6737460151191774/019e1e17-ff75-7656-a65a-aae77095eb40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thermofisher.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2722411514048724587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thermo-fisher-scientific",
      "poi_latitude": "35.6607475",
      "poi_longitude": "-77.3594665",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-766-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-2Xvz_mrokRa75OG9nyxyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d4950150-2875-44a8-a440-b9b944cac2c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Hyster-Yale Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5200 M.L.K. Jr Hwy, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e17-fe41-761a-9e80-03cbf93fd4dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e17-fe41-761a-9e80-03cbf93fd4dc",
        "storage_key": "property/6737460151191774/019e1e17-fe41-761a-9e80-03cbf93fd4dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hyster-yale.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1137846916430718196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyster-yale-group",
      "poi_latitude": "35.6521248",
      "poi_longitude": "-77.34406419999999",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 252-931-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_eMPrUTmrokR9GSg7r1xyg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_c38a218b-1134-4cfd-849c-1d85b9c2b55c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "poi_name": "Physicians East, PA - Primary Care - Arlington",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1850 W Arlington Blvd, Greenville, NC 27834, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e18-00ac-776f-b250-478f00a29cbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e18-00ac-776f-b250-478f00a29cbc",
        "storage_key": "property/6737460151191774/019e1e18-00ac-776f-b250-478f00a29cbc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.physicianseast.com/?utm_source=Google&utm_medium=Yext&y_source=1_MTc4ODU2NzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13101627878952711899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "physicians-east-pa---primary-care---arlington",
      "poi_latitude": "35.5992092",
      "poi_longitude": "-77.4051077",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 252-413-6202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e15-ab66-7268-9a74-4b27eec19849",
        "storage_key": "property/6737460151191774/019e1e15-ab66-7268-9a74-4b27eec19849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTyBMZ7CrokR27ZU-CNV0rU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d6f89f8c99055c2f2716ab17",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bdb0a4cf106d954f35595f63",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e4af1306b7970ed0f54b7bd0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d9a1be76452cf8350e1d4f5b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a2a0df80cde5cdc5386274a3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_86e2b9be2a5254caa03f5a4b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_c3514db3-541f-478b-9474-4cbb483ac7d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "rating": "5.0",
      "name": "Jamariah Griffin",
      "text": "Ms. Faith Jones has been amazing to work with. She’s always friendly, professional, and quick to help whenever I have a question or need something taken care of. You can tell she really cares about the residents and takes pride in what she does. I really appreciate all the help she’s given and it definitely makes living here a better experience.",
      "date": "2026-02-28",
      "title": "false"
    },
    {
      "id": "custom_9a191acb-263a-45aa-9086-7578024ac463",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "rating": "5.0",
      "name": "Quandarian Lewis",
      "text": "Ms. Jones did an excellent job giving me a tour of the apartment. She was very friendly, professional, and made the whole experience comfortable and easy. She took the time to answer my questions and explained everything clearly. I really appreciated her positive attitude and helpfulness throughout the tour. Overall, she did a great job and made the visit a very pleasant experience.",
      "date": "2026-02-23",
      "title": "false"
    },
    {
      "id": "custom_3265282e-44db-4c66-ab1e-64c0d741023d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "rating": "4",
      "name": "Ronda Boyd",
      "text": "I have been living here for a bit over 3 years now and I have enjoyed very much. Even though there has been some changes, the staff has been very patient and helpful to make sure the tenants are happy and understand new processes. Thanks to Ms Chy-Lea for all of her assistance when I needed help. All the staff are super nice and helpful. ❤️",
      "date": "2025-10-25",
      "title": "false"
    },
    {
      "id": "custom_3ee91160-c758-4715-84b2-636693dfcc23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "rating": "5.0",
      "name": "Chrystall Jerome",
      "text": "I wanted to drop in and share my experience which Started with an amazing individual that took the time to show me around, Faith.  She was very kind and patient, also informed me of every little detail that i needed to know. In addition to the beautiful space she showed me , including different layout options.\n",
      "date": "2025-07-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a101a452-ac25-4703-abfb-f7597237e8fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019e1e15-6fc8-73ad-8d6f-21067ae44113.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e15-6fc8-73ad-8d6f-21067ae44113",
        "storage_key": "property/6737460151191774/019e1e15-6fc8-73ad-8d6f-21067ae44113.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=67257171935b3a693603c81c"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01994014-e674-77e9-84b5-dc788fa8836a",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-waterford-place-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774"
    },
    {
      "lead_collector_id": "01996476-2ac9-734e-a2e3-91f9b793507d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-waterford-place-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "waterford-place-in-unit-laundry-greenville-nc",
      "search_query": "apartments with in-unit laundry Greenville NC",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover apartments with in-unit laundry at Waterford Place, nestled in West Greenville, NC. Experience the ideal blend of comfort and convenience.",
      "page_copy": "Welcome to Waterford Place, where the convenience of apartments with in-unit laundry meets modern living in Greenville, NC. Our community boasts an array of amenities designed to enhance your lifestyle, from a state-of-the-art 24-hour fitness center to a relaxing pool area to unwind after a long day.\n\nChoose from spacious one, two, or three-bedroom floor plans tailored to suit your needs. Alongside in-unit laundry facilities, residents benefit from an island kitchen, providing a perfect blend of style and function. Experience the combination of elegance and efficiency at Waterford Place, a leading apartment community in West Greenville, NC. Make your move today and join our vibrant community!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Greenville, NC",
      "seo_description": "Discover convenience at Waterford Place in Greenville, NC, offering spacious apartments with in-unit laundry and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-waterford-place",
      "search_query": "dog friendly apartments with dog park West Greenville",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in West Greenville",
      "h2_subtitle": "Find dog friendly apartments with a dog park at Waterford Place. Located in the heart of West Greenville, we're perfect for pet owners.",
      "page_copy": "Welcome to Waterford Place, your ideal choice for dog friendly apartments in West Greenville. Our community not only welcomes pets but also features an on-site dog park, providing a safe and fun environment for your furry friends. \n\nBeyond our pet-friendly amenities, Waterford Place offers a mix of modern comforts and convenience. Enjoy stylish one, two, or three-bedroom layouts complete with spacious interiors, an island kitchen, and in-unit laundry for added ease. Our amenities, including a dog park, gas fire pit, and a 24-hour fitness center, make Waterford Place the perfect place to live in Greenville, NC. Join us and let your pets thrive here, too!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments with Dog Park in Greenville",
      "seo_description": "Waterford Place in West Greenville offers dog friendly apartments with a dog park and premium amenities. Perfect for you and your pets!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "apartments-with-pool-waterford-place-greenville",
      "search_query": "apartments with pool in Greenville 27834",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Greenville, 27834",
      "h2_subtitle": "Discover apartments with a refreshing pool at Waterford Place, situated in Greenville, NC, 27834, offering an unmatched lifestyle experience.",
      "page_copy": "Welcome to Waterford Place, where our apartments with a pool provide the perfect retreat in Greenville, NC, 27834. Dive into relaxation in our sparkling pool, ideal for both recreation and unwinding after a busy day.\n\nLocated in the charming neighborhood of West Greenville, Waterford Place combines exceptional amenities with a variety of floor plans including one, two, or three-bedroom options. Enjoy features like an island kitchen, in-unit laundry, and ample parking. Our vibrant community is designed to enhance your quality of life with a pool, a dog park, and a 24-hour fitness center. Discover Waterford Place, an inviting haven in Greenville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Greenville, NC 27834",
      "seo_description": "Relax in style at Waterford Place, Greenville, NC 27834, with premium amenities including a pool, ideal for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "modern-apartments-with-ac-waterford-place",
      "search_query": "modern apartments with air conditioning near Statonsburg Rd",
      "category": "Amenity",
      "h1_title": "Modern Apartments with AC Near Statonsburg Rd",
      "h2_subtitle": "Experience modern living in apartments with air conditioning near Statonsburg Rd. Waterford Place offers comfort and style in Greenville, NC.",
      "page_copy": "Waterford Place presents modern apartments with air conditioning, conveniently located near Statonsburg Rd in Greenville, NC. Our community is designed with comfort in mind, featuring contemporary layouts and luxurious amenities that cater to your lifestyle.\n\nChoose from spacious one, two, or three-bedroom apartment homes equipped with essential features like an island kitchen and in-unit laundry. Nestled in West Greenville, Waterford Place not only offers air conditioning but also an array of amenities including a pool, a dog park, and a 24-hour fitness center. Enjoy the convenience of living near Statonsburg Rd while relishing the peaceful atmosphere of our community. Make Waterford Place your home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with AC Near Statonsburg Rd",
      "seo_description": "Discover comfort at Waterford Place, modern apartments with air conditioning near Statonsburg Rd in Greenville, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "apartments-with-parking-security-waterford-place-greenville",
      "search_query": "Greenville NC apartments with parking and security system",
      "category": "Amenity",
      "h1_title": "Greenville NC Apartments with Parking & Security",
      "h2_subtitle": "Enjoy peace of mind at Waterford Place with ample parking and a security system. Located in Greenville, NC, we value your safety and comfort.",
      "page_copy": "At Waterford Place, we offer Greenville, NC apartments that prioritize your security and convenience. Enjoy ample parking and a robust security system, ensuring peace of mind for all our residents.\n\nWaterford Place is nestled in the friendly community of West Greenville. Our property features spacious one, two, or three-bedroom layouts equipped with modern amenities like an island kitchen and in-unit laundry. Beyond safety and practicality, we also offer a dog park, a pool, and a 24-hour fitness center. Discover a lifestyle that blends security with comfort at Waterford Place, your new home in Greenville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Greenville NC Apartments with Parking & Security",
      "seo_description": "Waterford Place offers Greenville, NC apartments with ample parking and a security system, ensuring safety and convenience in West Greenville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-waterford-place-west-greenville",
      "search_query": "two bedroom apartments in West Greenville NC",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in West Greenville, NC",
      "h2_subtitle": "Find spacious two-bedroom apartments in West Greenville, NC at Waterford Place. Enjoy modern amenities and a vibrant community atmosphere.",
      "page_copy": "Discover the perfect two-bedroom apartments in West Greenville, NC at Waterford Place. Our thoughtfully designed floor plans provide ample space and modern conveniences, ideal for singles, couples, or small families.\n\nNestled in the heart of West Greenville, Waterford Place offers more than just spacious interiors. Residents enjoy amenities like an island kitchen, in-unit laundry, and a refreshing pool. The community features include a dog park and a 24-hour fitness center, providing both relaxation and entertainment options. Experience a blend of comfort and style at Waterford Place, your ideal home in Greenville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in West Greenville, NC",
      "seo_description": "Explore two-bedroom apartments at Waterford Place in West Greenville, NC, offering comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-waterford-place-near-27834",
      "search_query": "one bedroom apartments near 27834",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near 27834",
      "h2_subtitle": "Explore one-bedroom apartments near 27834 at Waterford Place. Discover cozy living spaces with modern amenities in Greenville, NC.",
      "page_copy": "Waterford Place offers one-bedroom apartments near 27834, set in a vibrant community with the perfect blend of comfort and convenience. Our thoughtfully designed units provide ample space with modern features like island kitchens and security systems.\n\nLocated in Greenville, NC, Waterford Place ensures a dynamic lifestyle with amenities like a refreshing pool, 24-hour fitness center, and dog park. With easy access to Statonsburg Rd, our community combines the tranquility of West Greenville with the energetic pulse of the neighborhood. Make Waterford Place your new home for unparalleled living near 27834.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near 27834",
      "seo_description": "Find one-bedroom apartments at Waterford Place near 27834 in Greenville, NC, offering convenient and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191774",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-greenville-nc-waterford-place",
      "search_query": "three bedroom apartments in Greenville North Carolina",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Greenville, NC",
      "h2_subtitle": "Discover spacious three-bedroom apartments in Greenville, NC at Waterford Place. Enjoy modern amenities in a vibrant community setting.",
      "page_copy": "When searching for three-bedroom apartments in Greenville, North Carolina, Waterford Place stands out with spacious layouts and a host of amenities that cater to diverse lifestyles. Our three-bedroom units are designed with comfort and functionality in mind, featuring modern kitchens and ample living spaces.\n\nLocated in the heart of Greenville, Waterford Place offers more than just a home—it's a community. Residents enjoy a well-equipped fitness center, a sparkling pool, and dedicated spaces like a dog park for furry companions. Situated conveniently in West Greenville, our property provides easy access to local necessities while offering a peaceful retreat from the hustle and bustle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
      "featured_image_media": {
        "alt_text": "Lobby area with plush seating, coffee table, and entryway.",
        "public_id": "019d076f-2d9e-76c9-96d8-da5dd847d637",
        "storage_key": "property/6737460151191774/019d076f-2d9e-76c9-96d8-da5dd847d637.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Greenville, NC",
      "seo_description": "Explore three-bedroom apartments at Waterford Place in Greenville, NC, offering modern living spaces and comprehensive community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3415"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483265"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5026485"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KJ7QWBB8"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "252-680-1958"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "252-651-3772"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "252-680-2097"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "252-680-2142"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "252-651-3689"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "252-680-2017"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "252-651-3770"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "252-651-3978"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "252-899-2698"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "252-672-2805"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "252-518-4391"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "252-680-2154"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "252-584-2465"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "252-616-3409"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "252-549-2452"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "252-629-5210"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "252-888-1068"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "252-645-2120"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321266755"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "252-651-3728"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "252-525-4947"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "a9d9b9811ef11ee1"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "252-512-6788"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "252-680-2049"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "252-651-3885"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "252-645-2562"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "252-651-3701"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "252-680-2028"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "252-680-2063"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "252-651-3620"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.liveatwaterfordplaceapts.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191774/019e84a3-f420-74be-941a-620772ded094.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "252-651-3908"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "252-672-2805"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3415",
  "custom_repli_id": "5028483265",
  "custom_realpage_id": "5026485",
  "custom_knock_a_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=a",
  "custom_knock_g_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=g",
  "custom_knock_r_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=r",
  "custom_knock_w_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-KJ7QWBB8",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "252-680-1958",
  "custom_knock_ads_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "252-651-3772",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=psa",
  "custom_knock_r_number": "252-680-2097",
  "custom_knock_w_number": "252-680-2142",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "252-651-3689",
  "custom_knock_amap_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=amap",
  "custom_knock_ar_number": "252-680-2017",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "252-651-3770",
  "custom_knock_fb_number": "252-651-3978",
  "custom_knock_fl_number": "252-899-2698",
  "custom_knock_gp_number": "252-672-2805",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "252-518-4391",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=bcard",
  "custom_knock_bnr_number": "252-680-2154",
  "custom_knock_cfres_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "252-584-2465",
  "custom_knock_lgp_number": "252-616-3409",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "252-549-2452",
  "custom_knock_psa_number": "252-629-5210",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "252-888-1068",
  "custom_knock_bandit_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=flyers",
  "custom_knock_osoc_number": "252-645-2120",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321266755",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "252-651-3728",
  "custom_knock_cfres_number": "252-525-4947",
  "custom_knock_chatgpt_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "a9d9b9811ef11ee1",
  "custom_knock_dirmail_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "252-512-6788",
  "custom_knock_propbro_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=propbro",
  "custom_knock_bandit_number": "252-680-2049",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "252-651-3885",
  "custom_knock_outbound_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "252-645-2562",
  "custom_knock_dirmail_number": "252-651-3701",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "252-680-2028",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "252-680-2063",
  "custom_knock_revcards_number": "252-651-3620",
  "custom_knock_maintenance_link": "https://www.liveatwaterfordplaceapts.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191774/019e84a3-f420-74be-941a-620772ded094.mp4",
  "custom_knock_maintenance_number": "252-651-3908",
  "custom_ppc_tracking_phone_number": "252-672-2805"
};

export const generatedAt = '2026-10-07T17:14:57.162Z';
